import Enums from "@/enums/enums";
import paymentHelper from "@/helper/paymentHelper";
import transactionItemHelper from "@/helper/transactionItemHelper";
import userHelper from "@/helper/userHelper";
import i18n from "@/locales/i18n";
import transactionHelper from "@/service/transaction/transactionHelper";

function SortingData(selectedBillingNoteTransactionList) {
  selectedBillingNoteTransactionList.sort((a, b) => {
    let dateTimeA = new Date(a.date).getTime();
    let dateTimeB = new Date(b.date).getTime();
    if (dateTimeA == dateTimeB) {
      return a.transactionNumber > b.transactionNumber ? 1 : -1;
    } else {
      return dateTimeA > dateTimeB ? 1 : -1;
    }
  });
  return selectedBillingNoteTransactionList;
}
function ConvertToBillingNoteTransactionItemForCreate(billingNoteTransactionItemRaw) {
  return {
    description: billingNoteTransactionItemRaw.description,
    vatType: billingNoteTransactionItemRaw.vatType,
    discountType: billingNoteTransactionItemRaw.discountType,
    accountId: billingNoteTransactionItemRaw.accountId,
    productTemplateId: billingNoteTransactionItemRaw.productTemplateId,
    assetTemplateId: billingNoteTransactionItemRaw.assetTemplateId,
    assetId: billingNoteTransactionItemRaw.assetId,
    quantity: billingNoteTransactionItemRaw.quantity.ToPeakTransactionItemFormat(),
    isDescriptionOnly: billingNoteTransactionItemRaw.isDescriptionOnly,
    whtAmountType: billingNoteTransactionItemRaw.whtAmountType,
    sequenceNumber: billingNoteTransactionItemRaw.sequenceNumber,
    fromCurrencyPrice: billingNoteTransactionItemRaw.fromCurrencyPrice,
    fromCurrencyDiscount: billingNoteTransactionItemRaw.fromCurrencyDiscount,
    fromCurrencyWHTTotal: billingNoteTransactionItemRaw.fromCurrencyWHTTotal
      ? billingNoteTransactionItemRaw.fromCurrencyWHTTotal
      : 0,
    fromCurrencyNetTotal: billingNoteTransactionItemRaw.fromCurrencyNetTotal,
    fromCurrencyVatTotal: billingNoteTransactionItemRaw.fromCurrencyVatTotal,
    fromCurrencyPreVatTotal: billingNoteTransactionItemRaw.fromCurrencyPreVatTotal,
    fromCurrencyZeroVatTotal: billingNoteTransactionItemRaw.fromCurrencyZeroVatTotal,
    fromCurrencyVatExemptedTotal: billingNoteTransactionItemRaw.fromCurrencyVatExemptedTotal,
    fromCurrencySubTotalForcalculateWHT: billingNoteTransactionItemRaw.fromCurrencySubTotalForcalculateWHT,
    toCurrencyPrice: billingNoteTransactionItemRaw.toCurrencyPrice.ToPeakTransactionItemFormat(),
    toCurrencyDiscount: billingNoteTransactionItemRaw.toCurrencyDiscount,
    toCurrencyWHTTotal: billingNoteTransactionItemRaw.toCurrencyWHTTotal
      ? billingNoteTransactionItemRaw.toCurrencyWHTTotal
      : 0,
    toCurrencyNetTotal: billingNoteTransactionItemRaw.toCurrencyNetTotal.FormatMoney(),
    toCurrencyVatTotal: billingNoteTransactionItemRaw.toCurrencyVatTotal,
    toCurrencyPreVatTotal: billingNoteTransactionItemRaw.toCurrencyPreVatTotal,
    toCurrencyZeroVatTotal: billingNoteTransactionItemRaw.toCurrencyZeroVatTotal,
    toCurrencyVatExemptedTotal: billingNoteTransactionItemRaw.toCurrencyVatExemptedTotal,
    toCurrencySubTotalForcalculateWHT: billingNoteTransactionItemRaw.toCurrencySubTotalForcalculateWHT,
    fromCurrencyPriceDefault: billingNoteTransactionItemRaw.fromCurrencyPrice,
    fromCurrencyDiscountDefault: billingNoteTransactionItemRaw.fromCurrencyDiscount,
    fromCurrencyWHTTotalDefault: billingNoteTransactionItemRaw.fromCurrencyWHTTotal
      ? billingNoteTransactionItemRaw.fromCurrencyWHTTotal
      : 0,
    fromCurrencyNetTotalDefault: billingNoteTransactionItemRaw.fromCurrencyNetTotal,
    fromCurrencyVatTotalDefault: billingNoteTransactionItemRaw.fromCurrencyVatTotal,
    fromCurrencyPreVatTotalDefault: billingNoteTransactionItemRaw.fromCurrencyPreVatTotal,
    fromCurrencyZeroVatTotalDefault: billingNoteTransactionItemRaw.fromCurrencyZeroVatTotal,
    fromCurrencyVatExemptedTotalDefault: billingNoteTransactionItemRaw.fromCurrencyVatExemptedTotal,
    fromCurrencySubTotalForcalculateWHTDefault: billingNoteTransactionItemRaw.fromCurrencySubTotalForcalculateWHT,
    toCurrencyPriceDefault: billingNoteTransactionItemRaw.toCurrencyPrice.ToPeakTransactionItemFormat(),
    toCurrencyDiscountDefault: billingNoteTransactionItemRaw.toCurrencyDiscount,
    toCurrencyWHTTotalDefault: billingNoteTransactionItemRaw.toCurrencyWHTTotal
      ? billingNoteTransactionItemRaw.toCurrencyWHTTotal
      : 0,
    toCurrencyNetTotalDefault: billingNoteTransactionItemRaw.toCurrencyNetTotal.FormatMoney(),
    toCurrencyVatTotalDefault: billingNoteTransactionItemRaw.toCurrencyVatTotal,
    toCurrencyPreVatTotalDefault: billingNoteTransactionItemRaw.toCurrencyPreVatTotal,
    toCurrencyZeroVatTotalDefault: billingNoteTransactionItemRaw.toCurrencyZeroVatTotal,
    toCurrencyVatExemptedTotalDefault: billingNoteTransactionItemRaw.toCurrencyVatExemptedTotal,
    toCurrencySubTotalForcalculateWHTDefault: billingNoteTransactionItemRaw.toCurrencySubTotalForcalculateWHT,
  };
}
function ConvertToBillingNoteTransactionItemListForCreate(billingNoteTransactionItemRawList) {
  const billingNoteTransactionItemList = [];
  if (billingNoteTransactionItemRawList && billingNoteTransactionItemRawList.length > 0) {
    for (const billingNoteTransactionItemRaw of billingNoteTransactionItemRawList) {
      billingNoteTransactionItemList.push(ConvertToBillingNoteTransactionItemForCreate(billingNoteTransactionItemRaw));
    }
  }
  return billingNoteTransactionItemList;
}
function ConvertToBillingNoteTransactionReference(referenceRaw) {
  return {
    transactionId: referenceRaw.transactionId,
    transactionType: referenceRaw.transactionType,
    transactionNumber: referenceRaw.transactionNumber,
    date: referenceRaw.date,
    dueDate: referenceRaw.dueDate,
    billedToCurrencyAmount: referenceRaw.billedToCurrencyAmount,
    billedFromCurrencyAmount: referenceRaw.billedFromCurrencyAmount,
    fromCurrencyNetAmount: referenceRaw.fromCurrencyNetAmount,
    toCurrencyNetAmount: referenceRaw.toCurrencyNetAmount,
    fromCurrencyUId: referenceRaw.fromCurrencyUId,
    toCurrencyUId: referenceRaw.toCurrencyUId,
    exchangeRates: referenceRaw.exchangeRates,
    ratio: referenceRaw.ratio,
  };
}
function ConvertToBillingNoteTransactionReferenceList(referenceRawList) {
  const referenceList = [];
  if (referenceRawList && referenceRawList.length > 0) {
    for (const referenceRaw of referenceRawList) {
      referenceList.push(ConvertToBillingNoteTransactionReference(referenceRaw));
    }
  }
  return referenceList;
}
function ConvertBillingNoteTransactionItem(billingNoteTransactionItemRaw) {
  return {
    id: billingNoteTransactionItemRaw.description,
    billingNoteTransactionId: billingNoteTransactionItemRaw.billingNoteTransactionId,
    description: billingNoteTransactionItemRaw.description,
    vatType: billingNoteTransactionItemRaw.vatType,
    discountType: billingNoteTransactionItemRaw.discountType,
    accountId: billingNoteTransactionItemRaw.accountId,
    productTemplateId: billingNoteTransactionItemRaw.productTemplateId,
    assetTemplateId: billingNoteTransactionItemRaw.assetTemplateId,
    assetId: billingNoteTransactionItemRaw.assetId,
    quantity: billingNoteTransactionItemRaw.quantity,
    isDescriptionOnly: billingNoteTransactionItemRaw.isDescriptionOnly,
    whtAmountType: billingNoteTransactionItemRaw.whtAmountType,
    sequenceNumber: billingNoteTransactionItemRaw.sequenceNumber,
    fromCurrencyPrice: billingNoteTransactionItemRaw.fromCurrencyPrice,
    fromCurrencyDiscount: billingNoteTransactionItemRaw.fromCurrencyDiscount,
    fromCurrencyWHTTotal: billingNoteTransactionItemRaw.fromCurrencyWHTTotal,
    fromCurrencyNetTotal: billingNoteTransactionItemRaw.fromCurrencyNetTotal,
    fromCurrencyVatTotal: billingNoteTransactionItemRaw.fromCurrencyVatTotal,
    fromCurrencyPreVatTotal: billingNoteTransactionItemRaw.fromCurrencyPreVatTotal,
    fromCurrencyZeroVatTotal: billingNoteTransactionItemRaw.fromCurrencyZeroVatTotal,
    fromCurrencyVatExemptedTotal: billingNoteTransactionItemRaw.fromCurrencyVatExemptedTotal,
    fromCurrencySubTotalForcalculateWHT: billingNoteTransactionItemRaw.fromCurrencySubTotalForcalculateWHT,
    toCurrencyPrice: billingNoteTransactionItemRaw.toCurrencyPrice,
    toCurrencyDiscount: billingNoteTransactionItemRaw.toCurrencyDiscount,
    toCurrencyWHTTotal: billingNoteTransactionItemRaw.toCurrencyWHTTotal,
    toCurrencyNetTotal: billingNoteTransactionItemRaw.toCurrencyNetTotal,
    toCurrencyVatTotal: billingNoteTransactionItemRaw.toCurrencyVatTotal,
    toCurrencyPreVatTotal: billingNoteTransactionItemRaw.toCurrencyPreVatTotal,
    toCurrencyZeroVatTotal: billingNoteTransactionItemRaw.toCurrencyZeroVatTotal,
    toCurrencyVatExemptedTotal: billingNoteTransactionItemRaw.toCurrencyVatExemptedTotal,
    toCurrencySubTotalForcalculateWHT: billingNoteTransactionItemRaw.toCurrencySubTotalForcalculateWHT,
  };
}
function ConvertBillingNoteTransactionItemList(billingNoteTransactionItemRawList) {
  const billingNoteTransactionItemList = [];
  if (billingNoteTransactionItemRawList && billingNoteTransactionItemRawList.length > 0) {
    for (const billingNoteTransactionItemRaw of billingNoteTransactionItemRawList) {
      billingNoteTransactionItemList.push(ConvertBillingNoteTransactionItem(billingNoteTransactionItemRaw));
    }
  }
  return billingNoteTransactionItemList;
}
function ConvertToBillingNoteTransactionForCreate(_billingNoteTransaction) {
  if (_billingNoteTransaction) {
    let billingNoteTransactionTemplate = {
      transactionId: _billingNoteTransaction.transactionId,
      transactionType: _billingNoteTransaction.transactionType,
      isNoneOrNotSpecifyWht: _billingNoteTransaction.isNoneOrNotSpecifyWht,
      taxStatus: _billingNoteTransaction.taxStatus,
      referenceList: ConvertToBillingNoteTransactionReferenceList(_billingNoteTransaction.referenceList),
      summary: {
        netAmount: _billingNoteTransaction.summary.netAmount,
        preVatTotal: _billingNoteTransaction.summary.preVatTotal,
        subTotalForCalculateWht: _billingNoteTransaction.summary.subTotalForCalculateWht,
        vatExemptedTotal: _billingNoteTransaction.summary.vatExemptedTotal,
        vatTotal: _billingNoteTransaction.summary.vatTotal,
        whtTotal: _billingNoteTransaction.summary.whtTotal,
        zeroVatTotal: _billingNoteTransaction.summary.zeroVatTotal,
      },
      currency: {
        fromCurrencyUId: _billingNoteTransaction.currency.fromCurrencyUId,
        toCurrencyUId: _billingNoteTransaction.currency.toCurrencyUId,
        exchangeRates: _billingNoteTransaction.currency.exchangeRates,
        ratio: _billingNoteTransaction.currency.ratio,
        netAmount: _billingNoteTransaction.currency.netAmount,
        preVatTotal: _billingNoteTransaction.currency.preVatTotal,
        subTotalForCalculateWht: _billingNoteTransaction.currency.subTotalForCalculateWht,
        vatExemptedTotal: _billingNoteTransaction.currency.vatExemptedTotal,
        vatTotal: _billingNoteTransaction.currency.vatTotal,
        whtTotal: _billingNoteTransaction.currency.whtTotal,
        zeroVatTotal: _billingNoteTransaction.currency.zeroVatTotal,
      },
      billingNoteTransactionItemList: ConvertToBillingNoteTransactionItemListForCreate(
        _billingNoteTransaction.billingNoteTransactionItemList
      ),
    };
    return billingNoteTransactionTemplate;
  }
}
function MapTransactionToBillingNoteTransaction(billingNoteTransaction, selectedBillingNoteTransaction) {
  billingNoteTransaction.referenceList = selectedBillingNoteTransaction.referenceList;
  billingNoteTransaction.isNoneOrNotSpecifyWht = selectedBillingNoteTransaction.isNoneOrNotSpecifyWht;
  billingNoteTransaction.taxStatus = selectedBillingNoteTransaction.taxStatus;
  billingNoteTransaction.summaryDefault = { ...selectedBillingNoteTransaction.summary };
  billingNoteTransaction.currencyDefault = { ...selectedBillingNoteTransaction.currency };
  billingNoteTransaction.summary = { ...selectedBillingNoteTransaction.summary };
  billingNoteTransaction.currency = { ...selectedBillingNoteTransaction.currency };
  billingNoteTransaction.billingNoteTransactionItemList = [];
  billingNoteTransaction.billingNoteTransactionItemList.push(
    ...selectedBillingNoteTransaction.billingNoteTransactionItemList
  );
  billingNoteTransaction.billingNoteTransactionItemDefaultList = [];
  billingNoteTransaction.billingNoteTransactionItemDefaultList.push(
    ...selectedBillingNoteTransaction.billingNoteTransactionItemList
  );
}
function MapTransactionToBillingNoteTransactionList(
  billingNoteTransactionList,
  billingNoteTransactionInvoiceMap,
  billingNoteTransactionDebitNoteMap,
  billingNoteTransactionDepositMap,
  billingNoteTransactionInvoiceReceiptMap
) {
  if (billingNoteTransactionList && billingNoteTransactionList.length > 0) {
    for (const billingNoteTransaction of billingNoteTransactionList) {
      if (billingNoteTransaction.transactionType == Enums.TransactionType.Invoice) {
        MapTransactionToBillingNoteTransaction(
          billingNoteTransaction,
          billingNoteTransactionInvoiceMap[billingNoteTransaction.transactionId]
        );
      } else if (billingNoteTransaction.transactionType == Enums.TransactionType.DebitNote) {
        MapTransactionToBillingNoteTransaction(
          billingNoteTransaction,
          billingNoteTransactionDebitNoteMap[billingNoteTransaction.transactionId]
        );
      } else if (billingNoteTransaction.transactionType == Enums.TransactionType.Deposit) {
        MapTransactionToBillingNoteTransaction(
          billingNoteTransaction,
          billingNoteTransactionDepositMap[billingNoteTransaction.transactionId]
        );
      } else if (billingNoteTransaction.transactionType == Enums.TransactionType.InvoiceReceipt) {
        MapTransactionToBillingNoteTransaction(
          billingNoteTransaction,
          billingNoteTransactionInvoiceReceiptMap[billingNoteTransaction.transactionId]
        );
      }
    }
  }
}
function GetSelectedToBillingNoteTransaction(selectedTransactionRaw) {
  return {
    id: selectedTransactionRaw.id,
    transactionId: selectedTransactionRaw.transactionId,
    transactionType: selectedTransactionRaw.transactionType,
    transactionNumber: selectedTransactionRaw.number,
    transactionFromCurrencyNetAmount: selectedTransactionRaw.fromCurrencyNetAmount,
    transactionToCurrencyNetAmount: selectedTransactionRaw.toCurrencyNetAmount,
    date: selectedTransactionRaw.date,
    dueDate: selectedTransactionRaw.dueDate,
    isLock: false,
    taxStatus: 0,
    billedToCurrencyAmount: selectedTransactionRaw.billedAmount.ToNumber().ToAccountingRoundUpNumber(),
    billedFromCurrencyAmount: 0,
    referenceList: [],
    isNoneOrNotSpecifyWht: false,
    isBillingNoteTransactionItemOverNetTotal: false,
    billedPercent: 1,
    summary: {},
    currency: {},
    billingNoteTransactionItemList: [],
    summaryDefault: {},
    currencyDefault: {},
    billingNoteTransactionItemDefaultList: [],
  };
}
function GetBillingNoteTransactionItemToSelectedTransaction(billingNoteTransactionItemRaw, contactId) {
  return {
    id: 2 + ":" + billingNoteTransactionItemRaw.transactionId,
    transactionId: billingNoteTransactionItemRaw.transactionId,
    transactionType: billingNoteTransactionItemRaw.transactionType,
    date: billingNoteTransactionItemRaw.date,
    dueDate: billingNoteTransactionItemRaw.dueDate,
    number: billingNoteTransactionItemRaw.transactionNumber,
    fromCurrencyNetAmount: billingNoteTransactionItemRaw.transactionFromCurrencyNetAmount,
    toCurrencyNetAmount: billingNoteTransactionItemRaw.transactionToCurrencyNetAmount,
    contactId: contactId,
    toCurrencyUId: billingNoteTransactionItemRaw.currency.toCurrencyUId,
    billedAmount: billingNoteTransactionItemRaw.billedToCurrencyAmount.FormatMoney(),
    remainingPayment: 0,
    remainingWhtPayment: null,
    isNoneOrNotSpecifyWht: billingNoteTransactionItemRaw.isNoneOrNotSpecifyWht,
    billingAmountError: false,
    check: false,
  };
}
function GetSelectedToBillingNoteTransactionList(selectedTransactionRawList) {
  const selectedBillingNoteTransactionList = [];
  if (selectedTransactionRawList && selectedTransactionRawList.length > 0) {
    for (const selectedTransactionRaw of selectedTransactionRawList) {
      selectedBillingNoteTransactionList.push(GetSelectedToBillingNoteTransaction(selectedTransactionRaw));
    }
  }
  return selectedBillingNoteTransactionList;
}
function GetBillingNoteTransactionSummaryFullBilledAmount(selectedBillingNoteTransaction) {
  return {
    summary: {
      netAmount: selectedBillingNoteTransaction.summaryDefault.netAmount,
      preVatTotal: selectedBillingNoteTransaction.summaryDefault.preVatTotal,
      subTotalForCalculateWht: selectedBillingNoteTransaction.summaryDefault.subTotalForCalculateWht,
      vatExemptedTotal: selectedBillingNoteTransaction.summaryDefault.vatExemptedTotal,
      vatTotal: selectedBillingNoteTransaction.summaryDefault.vatTotal,
      whtTotal: selectedBillingNoteTransaction.summaryDefault.whtTotal,
      zeroVatTotal: selectedBillingNoteTransaction.summaryDefault.zeroVatTotal,
    },
    currency: {
      fromCurrencyUId: selectedBillingNoteTransaction.currencyDefault.fromCurrencyUId,
      toCurrencyUId: selectedBillingNoteTransaction.currencyDefault.toCurrencyUId,
      exchangeRates: selectedBillingNoteTransaction.currencyDefault.exchangeRates,
      ratio: selectedBillingNoteTransaction.currencyDefault.ratio,
      netAmount: selectedBillingNoteTransaction.currencyDefault.netAmount,
      preVatTotal: selectedBillingNoteTransaction.currencyDefault.preVatTotal,
      subTotalForCalculateWht: selectedBillingNoteTransaction.currencyDefault.subTotalForCalculateWht,
      vatExemptedTotal: selectedBillingNoteTransaction.currencyDefault.vatExemptedTotal,
      vatTotal: selectedBillingNoteTransaction.currencyDefault.vatTotal,
      whtTotal: selectedBillingNoteTransaction.currencyDefault.whtTotal,
      zeroVatTotal: selectedBillingNoteTransaction.currencyDefault.zeroVatTotal,
    },
  };
}
function GetBillingNoteTransactionSummaryByPatailBilledAmount(selectedBillingNoteTransaction) {
  return {
    summary: {
      netAmount: (
        selectedBillingNoteTransaction.billedPercent *
        selectedBillingNoteTransaction.summaryDefault.netAmount.ToNumber()
      ).ToAccountingRoundUpNumber(),
      preVatTotal: (
        selectedBillingNoteTransaction.billedPercent *
        selectedBillingNoteTransaction.summaryDefault.preVatTotal.ToNumber()
      ).ToAccountingRoundUpNumber(),
      subTotalForCalculateWht: (
        selectedBillingNoteTransaction.billedPercent *
        selectedBillingNoteTransaction.summaryDefault.subTotalForCalculateWht.ToNumber()
      ).ToAccountingRoundUpNumber(),
      vatExemptedTotal: (
        selectedBillingNoteTransaction.billedPercent *
        selectedBillingNoteTransaction.summaryDefault.vatExemptedTotal.ToNumber()
      ).ToAccountingRoundUpNumber(),
      vatTotal: (
        selectedBillingNoteTransaction.billedPercent * selectedBillingNoteTransaction.summaryDefault.vatTotal.ToNumber()
      ).ToAccountingRoundUpNumber(),
      whtTotal: (
        selectedBillingNoteTransaction.billedPercent * selectedBillingNoteTransaction.summaryDefault.whtTotal.ToNumber()
      ).ToAccountingRoundUpNumber(),
      zeroVatTotal: (
        selectedBillingNoteTransaction.billedPercent *
        selectedBillingNoteTransaction.summaryDefault.zeroVatTotal.ToNumber()
      ).ToAccountingRoundUpNumber(),
    },
    currency: {
      fromCurrencyUId: selectedBillingNoteTransaction.currencyDefault.fromCurrencyUId,
      toCurrencyUId: selectedBillingNoteTransaction.currencyDefault.toCurrencyUId,
      exchangeRates: selectedBillingNoteTransaction.currencyDefault.exchangeRates,
      ratio: selectedBillingNoteTransaction.currencyDefault.ratio,
      netAmount: (
        selectedBillingNoteTransaction.billedPercent *
        selectedBillingNoteTransaction.currencyDefault.netAmount.ToNumber()
      ).ToAccountingRoundUpNumber(),
      preVatTotal: (
        selectedBillingNoteTransaction.billedPercent *
        selectedBillingNoteTransaction.currencyDefault.preVatTotal.ToNumber()
      ).ToAccountingRoundUpNumber(),
      subTotalForCalculateWht: (
        selectedBillingNoteTransaction.billedPercent *
        selectedBillingNoteTransaction.currencyDefault.subTotalForCalculateWht.ToNumber()
      ).ToAccountingRoundUpNumber(),
      vatExemptedTotal: (
        selectedBillingNoteTransaction.billedPercent *
        selectedBillingNoteTransaction.currencyDefault.vatExemptedTotal.ToNumber()
      ).ToAccountingRoundUpNumber(),
      vatTotal: (
        selectedBillingNoteTransaction.billedPercent *
        selectedBillingNoteTransaction.currencyDefault.vatTotal.ToNumber()
      ).ToAccountingRoundUpNumber(),
      whtTotal: (
        selectedBillingNoteTransaction.billedPercent *
        selectedBillingNoteTransaction.currencyDefault.whtTotal.ToNumber()
      ).ToAccountingRoundUpNumber(),
      zeroVatTotal: (
        selectedBillingNoteTransaction.billedPercent *
        selectedBillingNoteTransaction.currencyDefault.zeroVatTotal.ToNumber()
      ).ToAccountingRoundUpNumber(),
    },
  };
}
function GetBillingNoteTransactionSummaryByBilledAmount(selectedBillingNoteTransaction) {
  if (
    selectedBillingNoteTransaction.billedToCurrencyAmount.ToAccountingRoundUpNumber() !=
    selectedBillingNoteTransaction.currencyDefault.netAmount.ToAccountingRoundUpNumber()
  ) {
    if (selectedBillingNoteTransaction.currencyDefault.netAmount != 0) {
      selectedBillingNoteTransaction.billedPercent =
        selectedBillingNoteTransaction.billedToCurrencyAmount /
        selectedBillingNoteTransaction.currencyDefault.netAmount;
    } else {
      selectedBillingNoteTransaction.billedPercent = 0;
      selectedBillingNoteTransaction.billedToCurrencyAmount = 0;
    }
    return GetBillingNoteTransactionSummaryByPatailBilledAmount(selectedBillingNoteTransaction);
  } else {
    selectedBillingNoteTransaction.billedPercent = 1;
    return GetBillingNoteTransactionSummaryFullBilledAmount(selectedBillingNoteTransaction);
  }
}
function SetBillingNoteTransactionSummary(selectedBillingNoteTransaction) {
  const billingNoteTransactionSummary = GetBillingNoteTransactionSummaryByBilledAmount(selectedBillingNoteTransaction);
  selectedBillingNoteTransaction.currency = billingNoteTransactionSummary.currency;
  selectedBillingNoteTransaction.summary = billingNoteTransactionSummary.summary;
}
function SetBillingNoteTransactionSummaryList(selectedBillingNoteTransactionList) {
  if (selectedBillingNoteTransactionList && selectedBillingNoteTransactionList.length > 0) {
    for (const selectedBillingNoteTransaction of selectedBillingNoteTransactionList) {
      SetBillingNoteTransactionSummary(selectedBillingNoteTransaction);
    }
  }
  return selectedBillingNoteTransactionList;
}
function GetBillingNoteSummary(transactionCreate) {
  const summary = {
    netAmount: 0,
    preVatTotal: 0,
    subTotalForCalculateWht: 0,
    vatExemptedTotal: 0,
    vatTotal: 0,
    whtTotal: 0,
    zeroVatTotal: 0,
    isNoneOrNotSpecifyWht: GetBillingNoteIsNoneOrNotSpecifyWht(transactionCreate.transactionItemList),
  };
  const currency = {
    fromCurrencyUId: 0,
    toCurrencyUId: 0,
    ratio: 1,
    netAmount: 0,
    preVatTotal: 0,
    subTotalForCalculateWht: 0,
    vatExemptedTotal: 0,
    vatTotal: 0,
    whtTotal: 0,
    zeroVatTotal: 0,
  };
  let index = 0;
  if (transactionCreate.transactionItemList && transactionCreate.transactionItemList.length > 0) {
    for (const selectedBillingNoteTransaction of transactionCreate.transactionItemList) {
      if (index == 0) {
        currency.fromCurrencyUId = selectedBillingNoteTransaction.currency.fromCurrencyUId;
        currency.toCurrencyUId = selectedBillingNoteTransaction.currency.toCurrencyUId;
        currency.ratio = selectedBillingNoteTransaction.currency.ratio;
      }
      index++;
      summary.netAmount += selectedBillingNoteTransaction.summary.netAmount.ToAccountingRoundUpNumber();
      summary.preVatTotal += selectedBillingNoteTransaction.summary.preVatTotal.ToAccountingRoundUpNumber();
      summary.vatExemptedTotal += selectedBillingNoteTransaction.summary.vatExemptedTotal.ToAccountingRoundUpNumber();
      summary.vatTotal += selectedBillingNoteTransaction.summary.vatTotal.ToAccountingRoundUpNumber();
      summary.zeroVatTotal += selectedBillingNoteTransaction.summary.zeroVatTotal.ToAccountingRoundUpNumber();
      currency.netAmount += selectedBillingNoteTransaction.currency.netAmount.ToAccountingRoundUpNumber();
      currency.preVatTotal += selectedBillingNoteTransaction.currency.preVatTotal.ToAccountingRoundUpNumber();
      currency.vatExemptedTotal += selectedBillingNoteTransaction.currency.vatExemptedTotal.ToAccountingRoundUpNumber();
      currency.vatTotal += selectedBillingNoteTransaction.currency.vatTotal.ToAccountingRoundUpNumber();
      currency.zeroVatTotal += selectedBillingNoteTransaction.currency.zeroVatTotal.ToAccountingRoundUpNumber();
      if (summary.isNoneOrNotSpecifyWht && selectedBillingNoteTransaction.isNoneOrNotSpecifyWht) {
        summary.subTotalForCalculateWht +=
          selectedBillingNoteTransaction.summary.subTotalForCalculateWht.ToAccountingRoundUpNumber();
        currency.subTotalForCalculateWht +=
          selectedBillingNoteTransaction.currency.subTotalForCalculateWht.ToAccountingRoundUpNumber();
      } else if (!summary.isNoneOrNotSpecifyWht && selectedBillingNoteTransaction.summary.whtTotal > 0) {
        summary.subTotalForCalculateWht +=
          selectedBillingNoteTransaction.summary.subTotalForCalculateWht.ToAccountingRoundUpNumber();
        currency.subTotalForCalculateWht +=
          selectedBillingNoteTransaction.currency.subTotalForCalculateWht.ToAccountingRoundUpNumber();
        summary.whtTotal += selectedBillingNoteTransaction.summary.whtTotal.ToAccountingRoundUpNumber();
        currency.whtTotal += selectedBillingNoteTransaction.currency.whtTotal.ToAccountingRoundUpNumber();
      }
    }
  }
  return {
    summary: summary,
    currency: currency,
  };
}
function GetBillingNoteIsNoneOrNotSpecifyWht(selectedBillingNoteTransactionList) {
  let isHaveNotSpecify = false;
  let isHaveWht = false;
  if (selectedBillingNoteTransactionList && selectedBillingNoteTransactionList.length > 0) {
    for (const selectedBillingNoteTransaction of selectedBillingNoteTransactionList) {
      if (selectedBillingNoteTransaction.isNoneOrNotSpecifyWht) {
        isHaveNotSpecify = true;
      }
      if (selectedBillingNoteTransaction.summary.whtTotal > 0) {
        isHaveWht = true;
      }
    }
  }
  return !isHaveWht && isHaveNotSpecify;
}
function SetBillingNoteTransactionListToTransactionCreate(
  transactionCreate,
  selectedBillingNoteTransactionList,
  selectedBillingNoteTransactionFromCreatePageMap
) {
  transactionCreate.transactionItemList = [];
  if (selectedBillingNoteTransactionList && selectedBillingNoteTransactionList.length > 0) {
    for (const selectedBillingNoteTransaction of selectedBillingNoteTransactionList) {
      const selectedBillingNoteTransactionFromCreatePage =
        selectedBillingNoteTransactionFromCreatePageMap[selectedBillingNoteTransaction.id];
      if (
        selectedBillingNoteTransactionFromCreatePage &&
        selectedBillingNoteTransactionFromCreatePage.billedToCurrencyAmount.ToAccountingRoundUpNumber() ==
          selectedBillingNoteTransaction.billedToCurrencyAmount.ToAccountingRoundUpNumber()
      ) {
        transactionCreate.transactionItemList.push(selectedBillingNoteTransactionFromCreatePage);
      } else {
        transactionCreate.transactionItemList.push(selectedBillingNoteTransaction);
      }
    }
  }
  return transactionCreate;
}
function SetBillingNoteSummaryToTransactionCreate(transactionCreate) {
  const billingNoteSummary = GetBillingNoteSummary(transactionCreate);
  transactionCreate.transactionSummary.zeroVatTotal = billingNoteSummary.summary.zeroVatTotal;
  transactionCreate.transactionSummary.vatExemptedTotal = billingNoteSummary.summary.vatExemptedTotal;
  transactionCreate.transactionSummary.netAmount = billingNoteSummary.summary.netAmount;
  transactionCreate.transactionSummary.subTotalForCalculateWht = billingNoteSummary.summary.subTotalForCalculateWht;
  transactionCreate.transactionSummary.whtTotal = billingNoteSummary.summary.whtTotal;
  transactionCreate.transactionSummary.remainPaymentNetAmount = billingNoteSummary.summary.netAmount;
  transactionCreate.transactionSummary.remainWhtPaymentNetAmount = billingNoteSummary.summary.whtTotal;
  transactionCreate.transactionSummary.isNoneOrNotSpecifyWht = billingNoteSummary.summary.isNoneOrNotSpecifyWht;
  transactionCreate.transactionSummary.vat.preVatTotal = billingNoteSummary.summary.preVatTotal;
  transactionCreate.transactionSummary.vat.vatTotal = billingNoteSummary.summary.vatTotal;
  transactionCreate.transactionCurrency = {
    fromCurrencyUid: billingNoteSummary.currency.fromCurrencyUId,
    toCurrencyUid: billingNoteSummary.currency.toCurrencyUId,
    currencyRatio: billingNoteSummary.currency.ratio,
    currencyPreVatTotal: billingNoteSummary.currency.preVatTotal,
    currencyZeroVatTotal: billingNoteSummary.currency.zeroVatTotal,
    currencyVatExemptedTotal: billingNoteSummary.currency.vatExemptedTotal,
    currencyVatTotal: billingNoteSummary.currency.vatTotal,
    currencyNetAmount: billingNoteSummary.currency.netAmount,
    currencySubTotalForCalculateWht: billingNoteSummary.currency.subTotalForCalculateWht,
    currencyWhtTotal: billingNoteSummary.currency.whtTotal,
  };
  transactionCreate.transactionCurrencySummary.toCurrencyUId = transactionCreate.transactionCurrency.toCurrencyUid;
  transactionCreate.currencyCode = transactionItemHelper
    .GetCurrencyMenuList()
    .find((x) => x.value === transactionCreate.transactionCurrency.toCurrencyUid).currencyCode;
  transactionCreate.transactionSummary.paymentWht = {
    isShow: transactionCreate.transactionSummary.whtTotal.ToAccountingRoundUpNumber() > 0 ? true : false,
    paymentNetAmount: transactionCreate.transactionSummary.netAmount.FormatMoney(),
    whtTotal: transactionCreate.transactionSummary.whtTotal.FormatMoney(),
  };
  return transactionCreate;
}
function CalculateToCurrencyPrice(billingNoteTransactionItem) {
  billingNoteTransactionItem.toCurrencyPrice = (
    (billingNoteTransactionItem.toCurrencyNetTotal.ToAccountingRoundUpNumber() -
      billingNoteTransactionItem.toCurrencyVatTotal.ToAccountingRoundUpNumber()) /
    billingNoteTransactionItem.quantity.ToNumber()
  ).ToPeakTransactionItemFormat();
}
function HandleBillingNoteTransactionItemToCurrency(billingNoteTransactionItem) {
  let toCurrencySubTotal =
    billingNoteTransactionItem.toCurrencyPreVatTotal.ToAccountingRoundUpNumber() +
    billingNoteTransactionItem.toCurrencyVatTotal.ToAccountingRoundUpNumber() +
    billingNoteTransactionItem.toCurrencyZeroVatTotal.ToAccountingRoundUpNumber() +
    billingNoteTransactionItem.toCurrencyVatExemptedTotal.ToAccountingRoundUpNumber();
  if (
    billingNoteTransactionItem.toCurrencyNetTotal.ToAccountingRoundUpNumber() !=
    toCurrencySubTotal.ToAccountingRoundUpNumber()
  ) {
    let diff =
      billingNoteTransactionItem.toCurrencyNetTotal.ToAccountingRoundUpNumber() -
      toCurrencySubTotal.ToAccountingRoundUpNumber();
    if (billingNoteTransactionItem.toCurrencyZeroVatTotal != 0) {
      billingNoteTransactionItem.toCurrencyZeroVatTotal += diff.ToAccountingRoundUpNumber();
    } else if (billingNoteTransactionItem.toCurrencyVatExemptedTotal != 0) {
      billingNoteTransactionItem.toCurrencyVatExemptedTotal += diff.ToAccountingRoundUpNumber();
    } else {
      billingNoteTransactionItem.toCurrencyPreVatTotal += diff.ToAccountingRoundUpNumber();
    }
  }
}
function CalculateFromCurrencyPrice(billingNoteTransactionItem) {
  billingNoteTransactionItem.fromCurrencyPrice = (
    (billingNoteTransactionItem.fromCurrencyNetTotal.ToAccountingRoundUpNumber() -
      billingNoteTransactionItem.fromCurrencyVatTotal.ToAccountingRoundUpNumber()) /
    billingNoteTransactionItem.quantity.ToNumber()
  ).ToPeakTransactionItemFormat();
}
function CalculateToCurrencyNetTotal(billingNoteTransactionItem, taxStatus) {
  billingNoteTransactionItem.toCurrencyNetTotal = (
    billingNoteTransactionItem.toCurrencyPrice.ToNumber() * billingNoteTransactionItem.quantity.ToNumber()
  ).ToAccountingRoundUpNumber();
  if (
    taxStatus == Enums.TaxStatus.ExcludeTax &&
    billingNoteTransactionItem.vatType == Enums.ProductVatType.SevenPercent
  ) {
    billingNoteTransactionItem.toCurrencyNetTotal += (
      billingNoteTransactionItem.toCurrencyNetTotal * 0.07
    ).ToAccountingRoundUpNumber();
  }
  billingNoteTransactionItem.toCurrencyNetTotal = billingNoteTransactionItem.toCurrencyNetTotal.FormatMoney();
}
function HandleBillingNoteTransactionItemFromCurrency(billingNoteTransactionItem) {
  let fromCurrencySubTotal =
    billingNoteTransactionItem.fromCurrencyPreVatTotal.ToAccountingRoundUpNumber() +
    billingNoteTransactionItem.fromCurrencyVatTotal.ToAccountingRoundUpNumber() +
    billingNoteTransactionItem.fromCurrencyZeroVatTotal.ToAccountingRoundUpNumber() +
    billingNoteTransactionItem.fromCurrencyVatExemptedTotal.ToAccountingRoundUpNumber();
  if (
    billingNoteTransactionItem.fromCurrencyNetTotal.ToAccountingRoundUpNumber() !=
    fromCurrencySubTotal.ToAccountingRoundUpNumber()
  ) {
    let diff =
      billingNoteTransactionItem.fromCurrencyNetTotal.ToAccountingRoundUpNumber() -
      fromCurrencySubTotal.ToAccountingRoundUpNumber();
    if (billingNoteTransactionItem.fromCurrencyZeroVatTotal != 0) {
      billingNoteTransactionItem.fromCurrencyZeroVatTotal += diff.ToAccountingRoundUpNumber();
    } else if (billingNoteTransactionItem.fromCurrencyVatExemptedTotal != 0) {
      billingNoteTransactionItem.fromCurrencyVatExemptedTotal += diff.ToAccountingRoundUpNumber();
    } else {
      billingNoteTransactionItem.fromCurrencyPreVatTotal += diff.ToAccountingRoundUpNumber();
    }
  }
}
function SetAllocateAmountForBillingNoteTransactionItemByBilledAmount(billedPercent, billingNoteTransactionItem) {
  billingNoteTransactionItem.toCurrencyNetTotal = (
    billingNoteTransactionItem.toCurrencyNetTotalDefault.ToAccountingRoundUpNumber() * billedPercent
  ).FormatMoney();
  billingNoteTransactionItem.toCurrencyVatTotal = (
    billingNoteTransactionItem.toCurrencyVatTotalDefault.ToAccountingRoundUpNumber() * billedPercent
  ).ToAccountingRoundUpNumber();
  billingNoteTransactionItem.toCurrencyPreVatTotal = (
    billingNoteTransactionItem.toCurrencyPreVatTotalDefault.ToAccountingRoundUpNumber() * billedPercent
  ).ToAccountingRoundUpNumber();
  billingNoteTransactionItem.toCurrencyZeroVatTotal = (
    billingNoteTransactionItem.toCurrencyZeroVatTotalDefault.ToAccountingRoundUpNumber() * billedPercent
  ).ToAccountingRoundUpNumber();
  billingNoteTransactionItem.toCurrencyVatExemptedTotal = (
    billingNoteTransactionItem.toCurrencyVatExemptedTotalDefault.ToAccountingRoundUpNumber() * billedPercent
  ).ToAccountingRoundUpNumber();
  billingNoteTransactionItem.toCurrencySubTotalForcalculateWHT = (
    billingNoteTransactionItem.toCurrencySubTotalForcalculateWHTDefault.ToAccountingRoundUpNumber() * billedPercent
  ).ToAccountingRoundUpNumber();
  billingNoteTransactionItem.toCurrencyWHTTotal = (
    billingNoteTransactionItem.toCurrencyWHTTotalDefault.ToAccountingRoundUpNumber() * billedPercent
  ).ToAccountingRoundUpNumber();
  billingNoteTransactionItem.fromCurrencyNetTotal = (
    billingNoteTransactionItem.fromCurrencyNetTotalDefault.ToAccountingRoundUpNumber() * billedPercent
  ).ToAccountingRoundUpNumber();
  billingNoteTransactionItem.fromCurrencyVatTotal = (
    billingNoteTransactionItem.fromCurrencyVatTotalDefault.ToAccountingRoundUpNumber() * billedPercent
  ).ToAccountingRoundUpNumber();
  billingNoteTransactionItem.fromCurrencyPreVatTotal = (
    billingNoteTransactionItem.fromCurrencyPreVatTotalDefault.ToAccountingRoundUpNumber() * billedPercent
  ).ToAccountingRoundUpNumber();
  billingNoteTransactionItem.fromCurrencyVatExemptedTotal = (
    billingNoteTransactionItem.fromCurrencyVatExemptedTotalDefault.ToAccountingRoundUpNumber() * billedPercent
  ).ToAccountingRoundUpNumber();
  billingNoteTransactionItem.fromCurrencyZeroVatTotal = (
    billingNoteTransactionItem.fromCurrencyZeroVatTotalDefault.ToAccountingRoundUpNumber() * billedPercent
  ).ToAccountingRoundUpNumber();
  billingNoteTransactionItem.fromCurrencySubTotalForcalculateWHT = (
    billingNoteTransactionItem.fromCurrencySubTotalForcalculateWHTDefault.ToAccountingRoundUpNumber() * billedPercent
  ).ToAccountingRoundUpNumber();
  billingNoteTransactionItem.fromCurrencyWHTTotal = (
    billingNoteTransactionItem.fromCurrencyWHTTotalDefault.ToAccountingRoundUpNumber() * billedPercent
  ).ToAccountingRoundUpNumber();
  HandleBillingNoteTransactionItemToCurrency(billingNoteTransactionItem);
  HandleBillingNoteTransactionItemFromCurrency(billingNoteTransactionItem);
}
function SetAllocateAmountForBillingNoteTransactionItemBySetToCurrencyNetTotal(
  billingNoteTransactionItem,
  toCurrencyNetTotal
) {
  let billedPercent = 0;
  if (billingNoteTransactionItem.toCurrencyNetTotalDefault.ToAccountingRoundUpNumber() != 0) {
    billedPercent =
      billingNoteTransactionItem.toCurrencyNetTotal.ToAccountingRoundUpNumber() /
      billingNoteTransactionItem.toCurrencyNetTotalDefault.ToAccountingRoundUpNumber();
  } else {
    billingNoteTransactionItem.toCurrencyNetTotal = 0;
  }
  billingNoteTransactionItem.toCurrencyNetTotal = toCurrencyNetTotal.FormatMoney();
  billingNoteTransactionItem.toCurrencyVatTotal = (
    billingNoteTransactionItem.toCurrencyVatTotalDefault.ToAccountingRoundUpNumber() * billedPercent
  ).ToAccountingRoundUpNumber();
  billingNoteTransactionItem.toCurrencyPreVatTotal = (
    billingNoteTransactionItem.toCurrencyPreVatTotalDefault.ToAccountingRoundUpNumber() * billedPercent
  ).ToAccountingRoundUpNumber();
  billingNoteTransactionItem.toCurrencyZeroVatTotal = (
    billingNoteTransactionItem.toCurrencyZeroVatTotalDefault.ToAccountingRoundUpNumber() * billedPercent
  ).ToAccountingRoundUpNumber();
  billingNoteTransactionItem.toCurrencyVatExemptedTotal = (
    billingNoteTransactionItem.toCurrencyVatExemptedTotalDefault.ToAccountingRoundUpNumber() * billedPercent
  ).ToAccountingRoundUpNumber();
  billingNoteTransactionItem.toCurrencySubTotalForcalculateWHT = (
    billingNoteTransactionItem.toCurrencySubTotalForcalculateWHTDefault.ToAccountingRoundUpNumber() * billedPercent
  ).ToAccountingRoundUpNumber();
  billingNoteTransactionItem.toCurrencyWHTTotal = (
    billingNoteTransactionItem.toCurrencyWHTTotalDefault.ToAccountingRoundUpNumber() * billedPercent
  ).ToAccountingRoundUpNumber();
  billingNoteTransactionItem.fromCurrencyNetTotal = (
    billingNoteTransactionItem.fromCurrencyNetTotalDefault.ToAccountingRoundUpNumber() * billedPercent
  ).ToAccountingRoundUpNumber();
  billingNoteTransactionItem.fromCurrencyVatTotal = (
    billingNoteTransactionItem.fromCurrencyVatTotalDefault.ToAccountingRoundUpNumber() * billedPercent
  ).ToAccountingRoundUpNumber();
  billingNoteTransactionItem.fromCurrencyPreVatTotal = (
    billingNoteTransactionItem.fromCurrencyPreVatTotalDefault.ToAccountingRoundUpNumber() * billedPercent
  ).ToAccountingRoundUpNumber();
  billingNoteTransactionItem.fromCurrencyVatExemptedTotal = (
    billingNoteTransactionItem.fromCurrencyVatExemptedTotalDefault.ToAccountingRoundUpNumber() * billedPercent
  ).ToAccountingRoundUpNumber();
  billingNoteTransactionItem.fromCurrencyZeroVatTotal = (
    billingNoteTransactionItem.fromCurrencyZeroVatTotalDefault.ToAccountingRoundUpNumber() * billedPercent
  ).ToAccountingRoundUpNumber();
  billingNoteTransactionItem.fromCurrencySubTotalForcalculateWHT = (
    billingNoteTransactionItem.fromCurrencySubTotalForcalculateWHTDefault.ToAccountingRoundUpNumber() * billedPercent
  ).ToAccountingRoundUpNumber();
  billingNoteTransactionItem.fromCurrencyWHTTotal = (
    billingNoteTransactionItem.fromCurrencyWHTTotalDefault.ToAccountingRoundUpNumber() * billedPercent
  ).ToAccountingRoundUpNumber();
  HandleBillingNoteTransactionItemToCurrency(billingNoteTransactionItem);
  HandleBillingNoteTransactionItemFromCurrency(billingNoteTransactionItem);
}
function SetAllocateAmountForBillingNoteTransactionItemFullBilledAmount(billingNoteTransactionItem) {
  billingNoteTransactionItem.toCurrencyNetTotal = billingNoteTransactionItem.toCurrencyNetTotalDefault.FormatMoney();
  billingNoteTransactionItem.toCurrencyVatTotal = billingNoteTransactionItem.toCurrencyVatTotalDefault;
  billingNoteTransactionItem.toCurrencyPreVatTotal = billingNoteTransactionItem.toCurrencyPreVatTotalDefault;
  billingNoteTransactionItem.toCurrencyZeroVatTotal = billingNoteTransactionItem.toCurrencyZeroVatTotalDefault;
  billingNoteTransactionItem.toCurrencyVatExemptedTotal = billingNoteTransactionItem.toCurrencyVatExemptedTotalDefault;
  billingNoteTransactionItem.toCurrencySubTotalForcalculateWHT =
    billingNoteTransactionItem.toCurrencySubTotalForcalculateWHTDefault;
  billingNoteTransactionItem.fromCurrencyNetTotal = billingNoteTransactionItem.fromCurrencyNetTotalDefault;
  billingNoteTransactionItem.fromCurrencyVatTotal = billingNoteTransactionItem.fromCurrencyVatTotalDefault;
  billingNoteTransactionItem.fromCurrencyPreVatTotal = billingNoteTransactionItem.fromCurrencyPreVatTotalDefault;
  billingNoteTransactionItem.fromCurrencyVatExemptedTotal =
    billingNoteTransactionItem.fromCurrencyVatExemptedTotalDefault;
  billingNoteTransactionItem.fromCurrencyZeroVatTotal = billingNoteTransactionItem.fromCurrencyZeroVatTotalDefault;
  billingNoteTransactionItem.fromCurrencySubTotalForcalculateWHT =
    billingNoteTransactionItem.fromCurrencySubTotalForcalculateWHTDefault;
  billingNoteTransactionItem.toCurrencyWHTTotal = billingNoteTransactionItem.toCurrencyWHTTotalDefault;
  billingNoteTransactionItem.fromCurrencyWHTTotal = billingNoteTransactionItem.fromCurrencyWHTTotalDefault;
}
function SetAllocateAmountForBillingNoteTransactionItemListByBilledAmount(selectedBillingNoteTransaction) {
  if (
    selectedBillingNoteTransaction.billingNoteTransactionItemList &&
    selectedBillingNoteTransaction.billingNoteTransactionItemList.length > 0
  ) {
    let toCurrencyNetTotal = 0;
    let fromCurrencyNetTotal = 0;
    for (const billingNoteTransactionItem of selectedBillingNoteTransaction.billingNoteTransactionItemList) {
      SetAllocateAmountForBillingNoteTransactionItemByBilledAmount(
        selectedBillingNoteTransaction.billedPercent,
        billingNoteTransactionItem
      );
      CalculateToCurrencyPrice(billingNoteTransactionItem);
      CalculateFromCurrencyPrice(billingNoteTransactionItem);
      toCurrencyNetTotal += billingNoteTransactionItem.toCurrencyNetTotal.ToNumber();
      fromCurrencyNetTotal += billingNoteTransactionItem.fromCurrencyNetTotal.ToNumber();
    }

    HandleBilledToCurrencyAmountDiff(selectedBillingNoteTransaction, toCurrencyNetTotal);
    HandleBilledFromCurrencyAmountDiff(selectedBillingNoteTransaction, fromCurrencyNetTotal);
  }
}
function HandleBilledToCurrencyAmountDiff(selectedBillingNoteTransaction, toCurrencyNetTotal) {
  const diffToCurrencyNetTotal =
    selectedBillingNoteTransaction.billedToCurrencyAmount.ToAccountingRoundUpNumber() - toCurrencyNetTotal;
  if (diffToCurrencyNetTotal != 0) {
    const billingNoteTransactionItem =
      selectedBillingNoteTransaction.billingNoteTransactionItemList[
        selectedBillingNoteTransaction.billingNoteTransactionItemList.length - 1
      ];
    billingNoteTransactionItem.toCurrencyNetTotal =
      billingNoteTransactionItem.toCurrencyNetTotal.ToNumber() + diffToCurrencyNetTotal.ToAccountingRoundUpNumber();

    CalculateBillingNoteTransactionItem(billingNoteTransactionItem);
    CalculateToCurrencyPrice(billingNoteTransactionItem);
  }
}

function HandleBilledFromCurrencyAmountDiff(selectedBillingNoteTransaction, fromCurrencyNetTotal) {
  const diffFromCurrencyNetTotal =
    selectedBillingNoteTransaction.billedFromCurrencyAmount.ToAccountingRoundUpNumber() - fromCurrencyNetTotal;

  if (diffFromCurrencyNetTotal != 0) {
    const billingNoteTransactionItem =
      selectedBillingNoteTransaction.billingNoteTransactionItemList[
        selectedBillingNoteTransaction.billingNoteTransactionItemList.length - 1
      ];
    billingNoteTransactionItem.fromCurrencyNetTotal =
      billingNoteTransactionItem.fromCurrencyNetTotal.ToNumber() + diffFromCurrencyNetTotal.ToAccountingRoundUpNumber();
    CalculateBillingNoteTransactionItem(billingNoteTransactionItem);
    CalculateToCurrencyPrice(billingNoteTransactionItem);
  }
}
function SetAllocateAmountForBillingNoteTransactionItem(selectedBillingNoteTransaction) {
  selectedBillingNoteTransaction.billingNoteTransactionItemList = [];
  if (
    selectedBillingNoteTransaction.billingNoteTransactionItemDefaultList &&
    selectedBillingNoteTransaction.billingNoteTransactionItemDefaultList.length > 0
  ) {
    selectedBillingNoteTransaction.billingNoteTransactionItemList.push(
      ...selectedBillingNoteTransaction.billingNoteTransactionItemDefaultList
    );
  }
  if (
    selectedBillingNoteTransaction.billingNoteTransactionItemList &&
    selectedBillingNoteTransaction.billingNoteTransactionItemList.length > 0 &&
    selectedBillingNoteTransaction.billedPercent != 1
  ) {
    SetAllocateAmountForBillingNoteTransactionItemListByBilledAmount(selectedBillingNoteTransaction);
  }
}
function SetAllocateAmountForBillingNoteTransactionItemList(selectedBillingNoteTransactionList) {
  if (selectedBillingNoteTransactionList && selectedBillingNoteTransactionList.length > 0) {
    for (const selectedBillingNoteTransaction of selectedBillingNoteTransactionList) {
      SetAllocateAmountForBillingNoteTransactionItem(selectedBillingNoteTransaction);
    }
  }
}
function CalculateBillingNoteTransactionItem(billingNoteTransactionItem) {
  if (
    billingNoteTransactionItem.toCurrencyNetTotal.ToAccountingRoundUpNumber() !=
    billingNoteTransactionItem.toCurrencyNetTotalDefault.ToAccountingRoundUpNumber()
  ) {
    SetAllocateAmountForBillingNoteTransactionItemBySetToCurrencyNetTotal(
      billingNoteTransactionItem,
      billingNoteTransactionItem.toCurrencyNetTotal
    );
  } else {
    SetAllocateAmountForBillingNoteTransactionItemFullBilledAmount(billingNoteTransactionItem);
  }
}
function GetBillingNoteTransactionSummaryByBillingNoteTransctionItem(billingNoteTransaction) {
  let summary = {
    netAmount: 0,
    preVatTotal: 0,
    subTotalForCalculateWht: 0,
    vatExemptedTotal: 0,
    vatTotal: 0,
    whtTotal: 0,
    zeroVatTotal: 0,
  };
  let currency = {
    netAmount: 0,
    preVatTotal: 0,
    subTotalForCalculateWht: 0,
    vatExemptedTotal: 0,
    vatTotal: 0,
    whtTotal: 0,
    zeroVatTotal: 0,
  };
  if (
    billingNoteTransaction.billingNoteTransactionItemList &&
    billingNoteTransaction.billingNoteTransactionItemList.length > 0
  ) {
    for (const billingNoteTransactionItem of billingNoteTransaction.billingNoteTransactionItemList) {
      currency.netAmount += billingNoteTransactionItem.toCurrencyNetTotal.ToAccountingRoundUpNumber();
      currency.preVatTotal += billingNoteTransactionItem.toCurrencyPreVatTotal.ToAccountingRoundUpNumber();
      currency.subTotalForCalculateWht +=
        billingNoteTransactionItem.toCurrencySubTotalForcalculateWHT.ToAccountingRoundUpNumber();
      currency.vatExemptedTotal += billingNoteTransactionItem.toCurrencyVatExemptedTotal.ToAccountingRoundUpNumber();
      currency.vatTotal += billingNoteTransactionItem.toCurrencyVatTotal.ToAccountingRoundUpNumber();
      currency.zeroVatTotal += billingNoteTransactionItem.toCurrencyZeroVatTotal.ToAccountingRoundUpNumber();

      summary.netAmount += billingNoteTransactionItem.fromCurrencyNetTotal.ToAccountingRoundUpNumber();
      summary.preVatTotal += billingNoteTransactionItem.fromCurrencyPreVatTotal.ToAccountingRoundUpNumber();
      summary.subTotalForCalculateWht +=
        billingNoteTransactionItem.fromCurrencySubTotalForcalculateWHT.ToAccountingRoundUpNumber();
      summary.vatExemptedTotal += billingNoteTransactionItem.fromCurrencyVatExemptedTotal.ToAccountingRoundUpNumber();
      summary.vatTotal += billingNoteTransactionItem.fromCurrencyVatTotal.ToAccountingRoundUpNumber();
      summary.zeroVatTotal += billingNoteTransactionItem.fromCurrencyZeroVatTotal.ToAccountingRoundUpNumber();
      if (billingNoteTransactionItem.toCurrencyWHTTotal) {
        currency.whtTotal += billingNoteTransactionItem.toCurrencyWHTTotal.ToAccountingRoundUpNumber();
      }
      if (billingNoteTransactionItem.fromCurrencyWHTTotal) {
        summary.whtTotal += billingNoteTransactionItem.fromCurrencyWHTTotal.ToAccountingRoundUpNumber();
      }
    }
  }
  if (billingNoteTransaction.isNoneOrNotSpecifyWht) {
    currency.whtTotal = null;
    summary.whtTotal = null;
  }
  return { summary: summary, currency: currency };
}
function SetBillingNoteTransactionSummaryByBillingNoteTransactionItem(billingNoteTransaction) {
  let billingNoteTransactionSummary =
    GetBillingNoteTransactionSummaryByBillingNoteTransctionItem(billingNoteTransaction);
  billingNoteTransaction.currency.netAmount = billingNoteTransactionSummary.currency.netAmount;
  billingNoteTransaction.currency.preVatTotal = billingNoteTransactionSummary.currency.preVatTotal;
  billingNoteTransaction.currency.subTotalForCalculateWht =
    billingNoteTransactionSummary.currency.subTotalForCalculateWht;
  billingNoteTransaction.currency.vatExemptedTotal = billingNoteTransactionSummary.currency.vatExemptedTotal;
  billingNoteTransaction.currency.vatTotal = billingNoteTransactionSummary.currency.vatTotal;
  billingNoteTransaction.currency.zeroVatTotal = billingNoteTransactionSummary.currency.zeroVatTotal;
  billingNoteTransaction.summary.netAmount = billingNoteTransactionSummary.summary.netAmount;
  billingNoteTransaction.summary.preVatTotal = billingNoteTransactionSummary.summary.preVatTotal;
  billingNoteTransaction.summary.subTotalForCalculateWht =
    billingNoteTransactionSummary.summary.subTotalForCalculateWht;
  billingNoteTransaction.summary.vatExemptedTotal = billingNoteTransactionSummary.summary.vatExemptedTotal;
  billingNoteTransaction.summary.vatTotal = billingNoteTransactionSummary.summary.vatTotal;
  billingNoteTransaction.summary.zeroVatTotal = billingNoteTransactionSummary.summary.zeroVatTotal;
  billingNoteTransaction.currency.whtTotal = billingNoteTransactionSummary.currency.whtTotal;
  billingNoteTransaction.summary.whtTotal = billingNoteTransactionSummary.summary.whtTotal;
}
export const ValidateEditBillingNoteTransaction = (netAmount, billedToCurrencyAmount) => {
  if (netAmount == billedToCurrencyAmount) {
    return true;
  }
  return false;
};
export const ValidateEditBillingNoteTransactionItem = (billingNoteTransactionItemList) => {
  if (!billingNoteTransactionItemList || billingNoteTransactionItemList.length == 0) {
    return false;
  }

  const isHaveBillingNoteTransactionItemOverNetTotal = billingNoteTransactionItemList.some(
    (x) => x.isBillingNoteTransactionItemOverNetTotal
  );
  return isHaveBillingNoteTransactionItemOverNetTotal ? false : true;
};
function ConvertFromInvoiceToBillingNoteTransaction(invoice) {
  return {
    id: 2 + ":" + invoice.id,
    transactionId: invoice.id,
    transactionType: 2,
    date: invoice.date,
    dueDate: invoice.dueDate,
    number: invoice.number,
    fromCurrencyNetAmount: invoice.netAmount,
    toCurrencyNetAmount: invoice.toCurrencyNetAmount,
    contactId: invoice.contactId,
    toCurrencyUId: invoice.toCurrencyUId,
    billedAmount: 0,
    remainingPayment: 0,
    remainingWhtPayment: null,
    isNoneOrNotSpecifyWht: false,
    billingAmountError: false,
    check: false,
  };
}
function ConvertFromInvoiceToBillingNoteTransactionList(invoiceList) {
  const billingNoteTransactionList = [];
  if (invoiceList && invoiceList.length > 0) {
    for (const invoice of invoiceList) {
      if (invoice.status == Enums.InvoiceStatus.Outstanding || invoice.status == Enums.InvoiceStatus.Overdue) {
        billingNoteTransactionList.push(ConvertFromInvoiceToBillingNoteTransaction(invoice));
      }
    }
  }
  return billingNoteTransactionList;
}
function ConvertFromDebitNoteToBillingNoteTransaction(debitNote) {
  return {
    id: 7 + ":" + debitNote.id,
    transactionId: debitNote.id,
    transactionType: 7,
    date: debitNote.date,
    dueDate: debitNote.dueDate,
    number: debitNote.number,
    fromCurrencyNetAmount: debitNote.netAmount,
    toCurrencyNetAmount: debitNote.toCurrencyNetAmount,
    contactId: debitNote.contactId,
    toCurrencyUId: debitNote.toCurrencyUId,
    billedAmount: 0,
    remainingPayment: debitNote.remainPaymentAmount ? debitNote.remainPaymentAmount : 0,
    remainingWhtPayment: null,
    isNoneOrNotSpecifyWht: false,
    billingAmountError: false,
    check: false,
  };
}
function ConvertFromDebitNoteToBillingNoteTransactionList(debitNoteList) {
  const billingNoteTransactionList = [];
  if (debitNoteList && debitNoteList.length > 0) {
    for (const debitNote of debitNoteList) {
      if (debitNote.status == Enums.DebitNoteStatus.Approved) {
        billingNoteTransactionList.push(ConvertFromDebitNoteToBillingNoteTransaction(debitNote));
      }
    }
  }
  return billingNoteTransactionList;
}
function ConvertFromDepositToBillingNoteTransaction(deposit) {
  return {
    id: 21 + ":" + deposit.id,
    transactionId: deposit.id,
    transactionType: 21,
    date: deposit.date,
    dueDate: deposit.dueDate,
    number: deposit.number,
    fromCurrencyNetAmount: deposit.fromCurrencyNetTotal,
    toCurrencyNetAmount: deposit.toCurrencyNetTotal,
    contactId: deposit.contactId,
    toCurrencyUId: deposit.toCurrencyUId,
    billedAmount: 0,
    remainingPayment: deposit.remainPaymentAmount ? deposit.remainPaymentAmount : 0,
    remainingWhtPayment: null,
    isNoneOrNotSpecifyWht: false,
    billingAmountError: false,
    check: false,
  };
}
function ConvertFromDepositToBillingNoteTransactionList(depositList) {
  const billingNoteTransactionList = [];
  if (depositList && depositList.length > 0) {
    for (const deposit of depositList) {
      if (deposit.status == Enums.DepositStatus.Outstanding || deposit.status == Enums.DepositStatus.Overdue) {
        billingNoteTransactionList.push(ConvertFromDepositToBillingNoteTransaction(deposit));
      }
    }
  }
  return billingNoteTransactionList;
}
function ConvertFromInvoiceReceiptToBillingNoteTransaction(invoiceReceipt) {
  return {
    id: Enums.TransactionType.InvoiceReceipt + ":" + invoiceReceipt.id,
    transactionId: invoiceReceipt.id,
    transactionType: Enums.TransactionType.InvoiceReceipt,
    date: invoiceReceipt.date,
    dueDate: invoiceReceipt.dueDate,
    number: invoiceReceipt.number,
    fromCurrencyNetAmount: invoiceReceipt.fromCurrencyNetTotal,
    toCurrencyNetAmount: invoiceReceipt.toCurrencyNetTotal,
    contactId: invoiceReceipt.contactId,
    toCurrencyUId: invoiceReceipt.toCurrencyUId,
    billedAmount: 0,
    remainingPayment: invoiceReceipt.remainPaymentAmount ? invoiceReceipt.remainPaymentAmount : 0,
    remainingWhtPayment: null,
    isNoneOrNotSpecifyWht: false,
    billingAmountError: false,
    check: false,
  };
}
function ConvertFromInvoiceReceiptToBillingNoteTransactionList(invoiceReceiptList) {
  const billingNoteTransactionList = [];
  if (invoiceReceiptList && invoiceReceiptList.length > 0) {
    for (const invoiceReceipt of invoiceReceiptList) {
      if (
        invoiceReceipt.status == Enums.InvoiceReceiptStatus.Outstanding ||
        invoiceReceipt.status == Enums.InvoiceReceiptStatus.Overdue
      ) {
        billingNoteTransactionList.push(ConvertFromInvoiceReceiptToBillingNoteTransaction(invoiceReceipt));
      }
    }
  }
  return billingNoteTransactionList;
}
function GetCreateBillingNoteTransactionItem(billingNoteTransactionItemRaw) {
  return {
    description: billingNoteTransactionItemRaw.description,
    vatType: billingNoteTransactionItemRaw.vatType,
    discountType: billingNoteTransactionItemRaw.discountType,
    accountId: billingNoteTransactionItemRaw.accountId,
    productTemplateId: billingNoteTransactionItemRaw.productTemplateId,
    assetTemplateId: billingNoteTransactionItemRaw.assetTemplateId,
    assetId: billingNoteTransactionItemRaw.assetId,
    quantity: billingNoteTransactionItemRaw.quantity,
    isDescriptionOnly: billingNoteTransactionItemRaw.isDescriptionOnly,
    whtAmountType: billingNoteTransactionItemRaw.whtAmountType,
    sequenceNumber: billingNoteTransactionItemRaw.sequenceNumber,
    fromCurrencyPrice: billingNoteTransactionItemRaw.fromCurrencyPrice,
    fromCurrencyDiscount: billingNoteTransactionItemRaw.fromCurrencyDiscount,
    fromCurrencyWHTTotal: billingNoteTransactionItemRaw.fromCurrencyWHTTotal,
    fromCurrencyNetTotal: billingNoteTransactionItemRaw.fromCurrencyNetTotal,
    fromCurrencyVatTotal: billingNoteTransactionItemRaw.fromCurrencyVatTotal,
    fromCurrencyPreVatTotal: billingNoteTransactionItemRaw.fromCurrencyPreVatTotal,
    fromCurrencyZeroVatTotal: billingNoteTransactionItemRaw.fromCurrencyZeroVatTotal,
    fromCurrencyVatExemptedTotal: billingNoteTransactionItemRaw.fromCurrencyVatExemptedTotal,
    fromCurrencySubTotalForcalculateWHT: billingNoteTransactionItemRaw.fromCurrencySubTotalForcalculateWHT,
    toCurrencyPrice: billingNoteTransactionItemRaw.toCurrencyPrice,
    toCurrencyDiscount: billingNoteTransactionItemRaw.toCurrencyDiscount,
    toCurrencyWHTTotal: billingNoteTransactionItemRaw.toCurrencyWHTTotal,
    toCurrencyNetTotal: billingNoteTransactionItemRaw.toCurrencyNetTotal,
    toCurrencyVatTotal: billingNoteTransactionItemRaw.toCurrencyVatTotal,
    toCurrencyPreVatTotal: billingNoteTransactionItemRaw.toCurrencyPreVatTotal,
    toCurrencyZeroVatTotal: billingNoteTransactionItemRaw.toCurrencyZeroVatTotal,
    toCurrencyVatExemptedTotal: billingNoteTransactionItemRaw.toCurrencyVatExemptedTotal,
    toCurrencySubTotalForcalculateWHT: billingNoteTransactionItemRaw.toCurrencySubTotalForcalculateWHT,
  };
}
function GetCreateBillingNoteTransactionItemList(billingNoteTransactionItemRawList) {
  const billingNoteTransactionItemList = [];
  if (billingNoteTransactionItemRawList && billingNoteTransactionItemRawList.length > 0) {
    for (const billingNoteTransactionItemRaw of billingNoteTransactionItemRawList) {
      billingNoteTransactionItemList.push(GetCreateBillingNoteTransactionItem(billingNoteTransactionItemRaw));
    }
  }
  return billingNoteTransactionItemList;
}
function GetCreateBillingNoteTransaction(billingNoteTransactionRaw) {
  return {
    transactionId: billingNoteTransactionRaw.transactionId,
    transactionType: billingNoteTransactionRaw.transactionType,
    billedToCurrencyAmount: billingNoteTransactionRaw.currency.netAmount,
    billedFromCurrencyAmount: billingNoteTransactionRaw.summary.netAmount,
    isNoneOrNotSpecifyWht: billingNoteTransactionRaw.isNoneOrNotSpecifyWht,
    summary: {
      netAmount: billingNoteTransactionRaw.summary.netAmount,
      preVatTotal: billingNoteTransactionRaw.summary.preVatTotal,
      subTotalForCalculateWht: billingNoteTransactionRaw.summary.subTotalForCalculateWht,
      vatExemptedTotal: billingNoteTransactionRaw.summary.vatExemptedTotal,
      vatTotal: billingNoteTransactionRaw.summary.vatTotal,
      whtTotal: billingNoteTransactionRaw.summary.whtTotal,
      zeroVatTotal: billingNoteTransactionRaw.summary.zeroVatTotal,
    },
    currency: {
      fromCurrencyUId: billingNoteTransactionRaw.currency.fromCurrencyUId,
      toCurrencyUId: billingNoteTransactionRaw.currency.toCurrencyUId,
      exchangeRates: billingNoteTransactionRaw.currency.exchangeRates,
      ratio: billingNoteTransactionRaw.currency.ratio,
      netAmount: billingNoteTransactionRaw.currency.netAmount,
      preVatTotal: billingNoteTransactionRaw.currency.preVatTotal,
      subTotalForCalculateWht: billingNoteTransactionRaw.currency.subTotalForCalculateWht,
      vatExemptedTotal: billingNoteTransactionRaw.currency.vatExemptedTotal,
      vatTotal: billingNoteTransactionRaw.currency.vatTotal,
      whtTotal: billingNoteTransactionRaw.currency.whtTotal,
      zeroVatTotal: billingNoteTransactionRaw.currency.zeroVatTotal,
    },
    billingNoteTransactionItemList: GetCreateBillingNoteTransactionItemList(
      billingNoteTransactionRaw.billingNoteTransactionItemList
    ),
  };
}
function GetCreateBillingNoteTransactionList(billingNoteTransactionRawList) {
  const billingNoteTransactionList = [];
  if (billingNoteTransactionRawList && billingNoteTransactionRawList.length > 0) {
    for (const billingNoteTransactionRaw of billingNoteTransactionRawList) {
      billingNoteTransactionList.push(GetCreateBillingNoteTransaction(billingNoteTransactionRaw));
    }
  }
  return billingNoteTransactionList;
}
function GetCreateBillingNoteInput(status, transaction) {
  let transactionCreate = {
    actionDate: null,
    id: 0,
    number: transaction.number.value,
    dueDate: transaction.dueDate.value.ToDateJsonString(),
    date: transaction.date.value.ToDateJsonString(),
    isVat: false,
    discount: transaction.transactionDiscount.value,
    discountType: transaction.transactionDiscount.discountType,
    remark: transaction.remark.text,
    status: 0,
    contact: {
      id: transaction.contact.id,
      contactCode: transaction.contact.contactCode,
    },
    payment: transactionHelper.ConvertPaymentForCreate(transaction.payment),
    financeTypeId: transaction.financeType,
    taxStatus: transaction.taxStatus.value,
    isDeleted: false,
    isCreatedTaxInvoice: transaction.issueTaxInvoice.value,
    isTaxDocument: transaction.issueTaxDocument.value,
    receivedBilligNoteNumber: transaction.reference.referenceName,
    referenceId: transaction.reference.referenceId,
    referenceType: transaction.reference.referenceTypeId,
    referencePaymentGroupId: transaction.reference.paymentGroupId,
    transactionSummary: {
      subTotal:
        transaction.transactionSummary.vat.preVatTotal.ToNumber() +
        transaction.transactionSummary.vatExemptedTotal.ToNumber() +
        transaction.transactionSummary.zeroVatTotal.ToNumber(),
      netAmount: transaction.transactionSummary.netAmount.ToNumber(),
      whtTotal: transaction.transactionSummary.whtTotal.ToNumber(),
      vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal.ToNumber(),
      zeroVatTotal: transaction.transactionSummary.zeroVatTotal.ToNumber(),
      preVatTotal: transaction.transactionSummary.vat.preVatTotal.ToNumber(),
      vatTotal: transaction.transactionSummary.vat.vatTotal.ToNumber(),
      subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht.ToNumber(),
      isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isNoneOrNotSpecifyWht,
      isServiceOnly: transaction.transactionSummary.isServiceOnly,
      sameProductVatType: transaction.transactionSummary.sameProductVatType,
    },
    transactionCurrency: transaction.transactionCurrency,
    fileList: [],
    tagList: transaction.tagList,
    transactionItemList: GetCreateBillingNoteTransactionList(transaction.transactionItemList),
    currencyModel: transaction.currencyModel,
  };

  if (status != null) {
    transactionCreate.status = status;
  }
  return { financeType: transaction.financeType, transaction: transactionCreate };
}
function GetBillingNoteTransactionForEdit(billingNoteTransaction) {
  const billingNoteTransactionForEdit = {
    billedFromCurrencyAmount: billingNoteTransaction.billedFromCurrencyAmount,
    billedPercent: billingNoteTransaction.billedPercent,
    billedToCurrencyAmount: billingNoteTransaction.billedToCurrencyAmount,
    billingNoteTransactionItemDefaultList: GetBillingNoteTransactionItemListForEdit(
      billingNoteTransaction.billingNoteTransactionItemDefaultList
    ),
    billingNoteTransactionItemList: GetBillingNoteTransactionItemListForEdit(
      billingNoteTransaction.billingNoteTransactionItemList
    ),
    isLock: true,
    referenceList: billingNoteTransaction.referenceList,
    taxStatus: billingNoteTransaction.taxStatus,
    currency: GetBillingNoteTransactionCurrencyForEdit(billingNoteTransaction.currency),
    currencyDefault: GetBillingNoteTransactionCurrencyForEdit(billingNoteTransaction.currencyDefault),
    date: billingNoteTransaction.date,
    dueDate: billingNoteTransaction.dueDate,
    id: billingNoteTransaction.id,
    isBillingNoteTransactionItemOverNetTotal: billingNoteTransaction.isBillingNoteTransactionItemOverNetTotal,
    isNoneOrNotSpecifyWht: billingNoteTransaction.isNoneOrNotSpecifyWht,
    referenceList: billingNoteTransaction.referenceList,
    summary: GetBillingNoteTransactionSummaryForEdit(billingNoteTransaction.summary),
    summaryDefault: GetBillingNoteTransactionSummaryForEdit(billingNoteTransaction.summaryDefault),
    transactionFromCurrencyNetAmount: billingNoteTransaction.transactionFromCurrencyNetAmount,
    transactionId: billingNoteTransaction.transactionId,
    transactionNumber: billingNoteTransaction.transactionNumber,
    transactionToCurrencyNetAmount: billingNoteTransaction.transactionToCurrencyNetAmount,
    transactionType: billingNoteTransaction.transactionType,
  };
  return billingNoteTransactionForEdit;
}
function GetBillingNoteTransactionItemListForEdit(transactionItemList) {
  const billingNoteTransactionItemListForEdit = [];
  if (transactionItemList && transactionItemList.length) {
    for (const transactionItem of transactionItemList) {
      billingNoteTransactionItemListForEdit.push(GetBillingNoteTransactionItemForEdit(transactionItem));
    }
  }
  return billingNoteTransactionItemListForEdit;
}
function GetBillingNoteTransactionItemForEdit(transactionItem) {
  const billingNoteTransactionItemForEdit = {
    description: transactionItem.description,
    vatType: transactionItem.vatType,
    discountType: transactionItem.discountType,
    accountId: transactionItem.accountId,
    productTemplateId: transactionItem.productTemplateId,
    assetTemplateId: transactionItem.assetTemplateId,
    assetId: transactionItem.assetId,
    quantity: transactionItem.quantity,
    isDescriptionOnly: transactionItem.isDescriptionOnly,
    whtAmountType: transactionItem.whtAmountType,
    sequenceNumber: transactionItem.sequenceNumber,
    fromCurrencyPrice: transactionItem.fromCurrencyPrice,
    fromCurrencyDiscount: transactionItem.fromCurrencyDiscount,
    fromCurrencyWHTTotal: transactionItem.fromCurrencyWHTTotal,
    fromCurrencyNetTotal: transactionItem.fromCurrencyNetTotal,
    fromCurrencyVatTotal: transactionItem.fromCurrencyVatTotal,
    fromCurrencyPreVatTotal: transactionItem.fromCurrencyPreVatTotal,
    fromCurrencyZeroVatTotal: transactionItem.fromCurrencyZeroVatTotal,
    fromCurrencyVatExemptedTotal: transactionItem.fromCurrencyVatExemptedTotal,
    fromCurrencySubTotalForcalculateWHT: transactionItem.fromCurrencySubTotalForcalculateWHT,
    toCurrencyPrice: transactionItem.toCurrencyPrice,
    toCurrencyDiscount: transactionItem.toCurrencyDiscount,
    toCurrencyWHTTotal: transactionItem.toCurrencyWHTTotal,
    toCurrencyNetTotal: transactionItem.toCurrencyNetTotal.FormatMoney(),
    toCurrencyVatTotal: transactionItem.toCurrencyVatTotal,
    toCurrencyPreVatTotal: transactionItem.toCurrencyPreVatTotal,
    toCurrencyZeroVatTotal: transactionItem.toCurrencyZeroVatTotal,
    toCurrencyVatExemptedTotal: transactionItem.toCurrencyVatExemptedTotal,
    toCurrencySubTotalForcalculateWHT: transactionItem.toCurrencySubTotalForcalculateWHT,
    fromCurrencyPriceDefault: transactionItem.fromCurrencyPriceDefault,
    fromCurrencyDiscountDefault: transactionItem.fromCurrencyDiscountDefault,
    fromCurrencyWHTTotalDefault: transactionItem.fromCurrencyWHTTotalDefault,
    fromCurrencyNetTotalDefault: transactionItem.fromCurrencyNetTotalDefault,
    fromCurrencyVatTotalDefault: transactionItem.fromCurrencyVatTotalDefault,
    fromCurrencyPreVatTotalDefault: transactionItem.fromCurrencyPreVatTotalDefault,
    fromCurrencyZeroVatTotalDefault: transactionItem.fromCurrencyZeroVatTotalDefault,
    fromCurrencyVatExemptedTotalDefault: transactionItem.fromCurrencyVatExemptedTotalDefault,
    fromCurrencySubTotalForcalculateWHTDefault: transactionItem.fromCurrencySubTotalForcalculateWHTDefault,
    toCurrencyPriceDefault: transactionItem.toCurrencyPriceDefault,
    toCurrencyDiscountDefault: transactionItem.toCurrencyDiscountDefault,
    toCurrencyWHTTotalDefault: transactionItem.toCurrencyWHTTotalDefault,
    toCurrencyNetTotalDefault: transactionItem.toCurrencyNetTotalDefault,
    toCurrencyVatTotalDefault: transactionItem.toCurrencyVatTotalDefault,
    toCurrencyPreVatTotalDefault: transactionItem.toCurrencyPreVatTotalDefault,
    toCurrencyZeroVatTotalDefault: transactionItem.toCurrencyZeroVatTotalDefault,
    toCurrencyVatExemptedTotalDefault: transactionItem.toCurrencyVatExemptedTotalDefault,
    toCurrencySubTotalForcalculateWHTDefault: transactionItem.toCurrencySubTotalForcalculateWHTDefault,
  };
  return billingNoteTransactionItemForEdit;
}
function GetBillingNoteTransactionCurrencyForEdit(currency) {
  const billingNoteTransactionItemCurrencyForEdit = {
    exchangeRates: currency.exchangeRates,
    fromCurrencyUId: currency.fromCurrencyUId,
    netAmount: currency.netAmount,
    preVatTotal: currency.preVatTotal,
    ratio: currency.ratio,
    subTotalForCalculateWht: currency.subTotalForCalculateWht,
    toCurrencyUId: currency.toCurrencyUId,
    vatExemptedTotal: currency.vatExemptedTotal,
    vatTotal: currency.vatTotal,
    whtTotal: currency.whtTotal,
    zeroVatTotal: currency.zeroVatTotal,
  };
  return billingNoteTransactionItemCurrencyForEdit;
}

function GetBillingNoteTransactionSummaryForEdit(summary) {
  const billingNoteTransactionSummaryForEdit = {
    netAmount: summary.netAmount,
    preVatTotal: summary.preVatTotal,
    subTotalForCalculateWht: summary.subTotalForCalculateWht,
    vatExemptedTotal: summary.vatExemptedTotal,
    vatTotal: summary.vatTotal,
    whtTotal: summary.whtTotal,
    zeroVatTotal: summary.zeroVatTotal,
  };
  return billingNoteTransactionSummaryForEdit;
}

function ConvertToBillingNoteTransactionItemForEdit(billingNoteTransactionItemRaw) {
  return {
    description: billingNoteTransactionItemRaw.description,
    vatType: billingNoteTransactionItemRaw.vatType,
    discountType: billingNoteTransactionItemRaw.discountType,
    accountId: billingNoteTransactionItemRaw.accountId,
    productTemplateId: billingNoteTransactionItemRaw.productTemplateId,
    assetTemplateId: billingNoteTransactionItemRaw.assetTemplateId,
    assetId: billingNoteTransactionItemRaw.assetId,
    quantity: billingNoteTransactionItemRaw.quantity.ToPeakTransactionItemFormat(),
    isDescriptionOnly: billingNoteTransactionItemRaw.isDescriptionOnly,
    whtAmountType: billingNoteTransactionItemRaw.whtAmountType,
    sequenceNumber: billingNoteTransactionItemRaw.sequenceNumber,
    fromCurrencyPrice: billingNoteTransactionItemRaw.fromCurrencyPrice,
    fromCurrencyDiscount: billingNoteTransactionItemRaw.fromCurrencyDiscount,
    fromCurrencyWHTTotal: billingNoteTransactionItemRaw.fromCurrencyWHTTotal
      ? billingNoteTransactionItemRaw.fromCurrencyWHTTotal
      : 0,
    fromCurrencyNetTotal: billingNoteTransactionItemRaw.fromCurrencyNetTotal,
    fromCurrencyVatTotal: billingNoteTransactionItemRaw.fromCurrencyVatTotal,
    fromCurrencyPreVatTotal: billingNoteTransactionItemRaw.fromCurrencyPreVatTotal,
    fromCurrencyZeroVatTotal: billingNoteTransactionItemRaw.fromCurrencyZeroVatTotal,
    fromCurrencyVatExemptedTotal: billingNoteTransactionItemRaw.fromCurrencyVatExemptedTotal,
    fromCurrencySubTotalForcalculateWHT: billingNoteTransactionItemRaw.fromCurrencySubTotalForcalculateWHT,
    toCurrencyPrice: billingNoteTransactionItemRaw.toCurrencyPrice.ToPeakTransactionItemFormat(),
    toCurrencyDiscount: billingNoteTransactionItemRaw.toCurrencyDiscount,
    toCurrencyWHTTotal: billingNoteTransactionItemRaw.toCurrencyWHTTotal
      ? billingNoteTransactionItemRaw.toCurrencyWHTTotal
      : 0,
    toCurrencyNetTotal: billingNoteTransactionItemRaw.toCurrencyNetTotal.FormatMoney(),
    toCurrencyVatTotal: billingNoteTransactionItemRaw.toCurrencyVatTotal,
    toCurrencyPreVatTotal: billingNoteTransactionItemRaw.toCurrencyPreVatTotal,
    toCurrencyZeroVatTotal: billingNoteTransactionItemRaw.toCurrencyZeroVatTotal,
    toCurrencyVatExemptedTotal: billingNoteTransactionItemRaw.toCurrencyVatExemptedTotal,
    toCurrencySubTotalForcalculateWHT: billingNoteTransactionItemRaw.toCurrencySubTotalForcalculateWHT,
    fromCurrencyPriceDefault: billingNoteTransactionItemRaw.fromCurrencyPrice,
    fromCurrencyDiscountDefault: billingNoteTransactionItemRaw.fromCurrencyDiscount,
    fromCurrencyWHTTotalDefault: billingNoteTransactionItemRaw.fromCurrencyWHTTotal
      ? billingNoteTransactionItemRaw.fromCurrencyWHTTotal
      : 0,
    fromCurrencyNetTotalDefault: billingNoteTransactionItemRaw.fromCurrencyNetTotal,
    fromCurrencyVatTotalDefault: billingNoteTransactionItemRaw.fromCurrencyVatTotal,
    fromCurrencyPreVatTotalDefault: billingNoteTransactionItemRaw.fromCurrencyPreVatTotal,
    fromCurrencyZeroVatTotalDefault: billingNoteTransactionItemRaw.fromCurrencyZeroVatTotal,
    fromCurrencyVatExemptedTotalDefault: billingNoteTransactionItemRaw.fromCurrencyVatExemptedTotal,
    fromCurrencySubTotalForcalculateWHTDefault: billingNoteTransactionItemRaw.fromCurrencySubTotalForcalculateWHT,
    toCurrencyPriceDefault: billingNoteTransactionItemRaw.toCurrencyPrice.ToPeakTransactionItemFormat(),
    toCurrencyDiscountDefault: billingNoteTransactionItemRaw.toCurrencyDiscount,
    toCurrencyWHTTotalDefault: billingNoteTransactionItemRaw.toCurrencyWHTTotal
      ? billingNoteTransactionItemRaw.toCurrencyWHTTotal
      : 0,
    toCurrencyNetTotalDefault: billingNoteTransactionItemRaw.toCurrencyNetTotal.FormatMoney(),
    toCurrencyVatTotalDefault: billingNoteTransactionItemRaw.toCurrencyVatTotal,
    toCurrencyPreVatTotalDefault: billingNoteTransactionItemRaw.toCurrencyPreVatTotal,
    toCurrencyZeroVatTotalDefault: billingNoteTransactionItemRaw.toCurrencyZeroVatTotal,
    toCurrencyVatExemptedTotalDefault: billingNoteTransactionItemRaw.toCurrencyVatExemptedTotal,
    toCurrencySubTotalForcalculateWHTDefault: billingNoteTransactionItemRaw.toCurrencySubTotalForcalculateWHT,
  };
}
function ConvertToBillingNoteTransactionItemListForEdit(billingNoteTransactionItemRawList) {
  const billingNoteTransactionItemList = [];
  if (billingNoteTransactionItemRawList && billingNoteTransactionItemRawList.length > 0) {
    for (const billingNoteTransactionItemRaw of billingNoteTransactionItemRawList) {
      billingNoteTransactionItemList.push(ConvertToBillingNoteTransactionItemForEdit(billingNoteTransactionItemRaw));
    }
  }
  return billingNoteTransactionItemList;
}
function GetEditSelectedToBillingNoteTransaction(billingNoteTransaction) {
  return {
    id: billingNoteTransaction.transactionType + ":" + billingNoteTransaction.transactionId,
    transactionId: billingNoteTransaction.transactionId,
    transactionType: billingNoteTransaction.transactionType,
    transactionNumber: billingNoteTransaction.transactionNumber,
    transactionFromCurrencyNetAmount: billingNoteTransaction.transactionFromCurrencyNetAmount,
    transactionToCurrencyNetAmount: billingNoteTransaction.transactionToCurrencyNetAmount,
    date: billingNoteTransaction.date,
    dueDate: billingNoteTransaction.dueDate,
    taxStatus: 0,
    isLock: true,
    billedToCurrencyAmount: billingNoteTransaction.billedToCurrencyAmount,
    billedFromCurrencyAmount: billingNoteTransaction.billedFromCurrencyAmount,
    referenceList: billingNoteTransaction.referenceList,
    isNoneOrNotSpecifyWht: billingNoteTransaction.isNoneOrNotSpecifyWht,
    isBillingNoteTransactionItemOverNetTotal: false,
    billedPercent: 1,
    summary: GetBillingNoteTransactionSummaryForEdit(billingNoteTransaction.summary),
    currency: GetBillingNoteTransactionCurrencyForEdit(billingNoteTransaction.currency),
    billingNoteTransactionItemList: ConvertToBillingNoteTransactionItemListForCreate(
      billingNoteTransaction.billingNoteTransactionItemList
    ),
    summaryDefault: {},
    currencyDefault: {},
    billingNoteTransactionItemDefaultList: [],
  };
}
function GetEditSelectedToBillingNoteTransactionList(billingNoteTransactionList) {
  const selectedBillingNoteTransactionList = [];
  if (billingNoteTransactionList && billingNoteTransactionList.length > 0) {
    for (const selectedTransactionRaw of billingNoteTransactionList) {
      selectedBillingNoteTransactionList.push(GetEditSelectedToBillingNoteTransaction(selectedTransactionRaw));
    }
  }
  return selectedBillingNoteTransactionList;
}
function SetEditBillingNote(transaction, transactionDetail) {
  transaction.documentType = Enums.DocumentType.Edit;
  transaction.id = transactionDetail.id.ToNumber();
  transaction.status = transactionDetail.transactionStatus;
  transaction.reference.referenceName = transactionDetail.referenceName;
  transaction.transactionDiscount.value = transactionDetail.discount.FormatMoney();
  transaction.transactionDiscount.discountType = transactionDetail.discountType;
  transaction.contact.id = transactionDetail.contactId;
  transaction.contact.contactCode = transactionDetail.contactCode;
  transaction.taxStatus.value = transactionDetail.taxStatus;
  transaction.taxStatus.isNotAuto = true;
  transaction.number.value = transactionDetail.number;
  transaction.date.value = new Date(transactionDetail.date).ToDateJsonString();
  transaction.dueDate.value = new Date(transactionDetail.dueDate).ToDateJsonString();
  transaction.dueDate.isNotAuto = true;
  transaction.remark.text = transactionDetail.remark;
  transaction.remark.isNotAuto = true;
  transaction.transactionItemList = GetEditSelectedToBillingNoteTransactionList(
    transactionDetail.billingNoteTransactionList
  );
  transaction.isNotAuto = true;
  transaction.userId = transactionDetail.userId;

  transaction.transactionCurrency = transactionDetail.transactionCurrency;
  transaction.transactionSummary.paymentWht = {
    isShow: transactionDetail.transactionSummary.whtTotal.FormatMoney() > 0 ? true : false,
    paymentNetAmount: transactionDetail.transactionSummary.netAmount.FormatMoney(),
    whtTotal: transactionDetail.transactionSummary.whtTotal.FormatMoney(),
  };
  transaction.transactionCurrencySummary.toCurrencyUId = transactionDetail.transactionCurrency.toCurrencyUid;
  transaction.transactionCurrencySummary.exchangeRate =
    transactionDetail.transactionCurrency.currencyExchangeRates.ToPeakTransactionItemFormat();
  transaction.transactionCurrencySummary.ratio = transactionDetail.transactionCurrency.currencyRatio;
  transaction.transactionCurrencySummary.vat.preVatTotalDefualt =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.preVatTotal =
    transactionDetail.transactionCurrency.currencyPreVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalDefualt =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotal =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vat.vatTotalBeforeEdit =
    transactionDetail.transactionCurrency.currencyVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.vatExemptedTotal =
    transactionDetail.transactionCurrency.currencyVatExemptedTotal.FormatMoney();
  transaction.transactionCurrencySummary.zeroVatTotal =
    transactionDetail.transactionCurrency.currencyZeroVatTotal.FormatMoney();
  transaction.transactionCurrencySummary.netAmount =
    transactionDetail.transactionCurrency.currencyNetAmount.FormatMoney();

  transaction.transactionSummary.vat.vatTotalDefualt = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.vatTotal = transactionDetail.transactionSummary.vatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotalDefualt =
    transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.vat.preVatTotal = transactionDetail.transactionSummary.preVatTotal.FormatMoney();
  transaction.transactionSummary.netAmount = transactionDetail.transactionSummary.netAmount.FormatMoney();
  transaction.transactionSummary.vatExemptedTotal = transactionDetail.transactionSummary.vatExemptedTotal.FormatMoney();
  transaction.transactionSummary.zeroVatTotal = transactionDetail.transactionSummary.zeroVatTotal.FormatMoney();
  transaction.transactionSummary.isServiceOnly = transactionDetail.transactionSummary.isServiceOnly;
  transaction.transactionSummary.isNoneOrNotSpecifyWht = transactionDetail.transactionSummary.isAllNoneOrNotSpecifyWht;
  transaction.transactionSummary.sameProductVatType = transactionDetail.transactionSummary.sameProductVatType;
  transaction.transactionSummary.subTotalForCalculateWht = transactionDetail.transactionSummary.subTotalForCalculateWht;
  transaction.transactionSummary.preVatTotal = transactionDetail.transactionSummary.preVatTotal;
  transaction.transactionSummary.taxExclusiveTotal =
    transactionDetail.transactionSummary.preVatTotal + transactionDetail.transactionSummary.zeroVatTotal;
  transaction.transactionSummary.vatTotal = transactionDetail.transactionSummary.vatTotal;
  transaction.transactionSummary.subTotal = transactionDetail.transactionSummary.subTotal;
  transaction.transactionSummary.remainPaymentNetAmount = transactionDetail.transactionSummary.netAmount; // Hot fixed 2209281503 เนื่องจาก billingnote เวลาร่างยอด remainingPayment ต้องเท่ากัีบ netamount
  transaction.transactionSummary.remainWhtPaymentNetAmount = transaction.transactionSummary.paymentWht.whtTotal =
    transactionDetail.transactionSummary.whtTotal;
  transaction.transactionSummary.paymentWht.paymentNetAmount =
    transaction.transactionSummary.netAmount.ToNumber() - transactionDetail.transactionSummary.whtTotal.ToNumber();
  transactionDetail.transactionSummary.remainWhtPaymentNetAmount;
  transaction.transactionSummary.whtTotal = transactionDetail.transactionSummary.whtTotal;
  if (transaction.financeType === Enums.FinanceType.OutFlow) {
    transaction.payment = transactionDetail.payment;
    paymentHelper.CalculateAllPaymentGroupSummary(transaction.payment);
    transaction.isNotSuggestionPayment = transactionDetail.isNotSuggestionPayment;
  }
}
function SetEditBillingNoteTransactionWithTransactionItem(
  transactionItem,
  editBillingNoteTransactionWithTransactionItem
) {
  transactionItem.taxStatus = editBillingNoteTransactionWithTransactionItem.taxStatus;
  transactionItem.summaryDefault = { ...editBillingNoteTransactionWithTransactionItem.summary };
  transactionItem.currencyDefault = { ...editBillingNoteTransactionWithTransactionItem.currency };
  transactionItem.billingNoteTransactionItemDefaultList = [];
  if (
    editBillingNoteTransactionWithTransactionItem.billingNoteTransactionItemList &&
    editBillingNoteTransactionWithTransactionItem.billingNoteTransactionItemList.length > 0
  ) {
    transactionItem.billingNoteTransactionItemDefaultList.push(
      ...editBillingNoteTransactionWithTransactionItem.billingNoteTransactionItemList
    );
  }
}
function LoadEditBillingNoteTransactionItem(billingNoteTransaction) {
  billingNoteTransaction.billingNoteTransactionItemList = [];
  SetBillingNoteTransactionSummary(billingNoteTransaction);
  SetAllocateAmountForBillingNoteTransactionItem(billingNoteTransaction);
  billingNoteTransaction.isLock = false;
}

function GetBillingNoteTransactionCurrencyDetail(currency) {
  const billingNoteTransactionItemCurrencyDetail = {
    exchangeRates: currency.exchangeRates,
    fromCurrencyUId: currency.fromCurrencyUId,
    netAmount: currency.netAmount,
    preVatTotal: currency.preVatTotal,
    ratio: currency.ratio,
    subTotalForCalculateWht: currency.subTotalForCalculateWht,
    toCurrencyUId: currency.toCurrencyUId,
    vatExemptedTotal: currency.vatExemptedTotal,
    vatTotal: currency.vatTotal,
    whtTotal: currency.whtTotal,
    zeroVatTotal: currency.zeroVatTotal,
  };
  return billingNoteTransactionItemCurrencyDetail;
}

function GetBillingNoteTransactionSummaryDetail(summary) {
  const billingNoteTransactionSummaryDetail = {
    netAmount: summary.netAmount,
    preVatTotal: summary.preVatTotal,
    subTotalForCalculateWht: summary.subTotalForCalculateWht,
    vatExemptedTotal: summary.vatExemptedTotal,
    vatTotal: summary.vatTotal,
    whtTotal: summary.whtTotal,
    zeroVatTotal: summary.zeroVatTotal,
  };
  return billingNoteTransactionSummaryDetail;
}
function GetBillingNoteTransactionDetail(billingNoteTransaction) {
  return {
    id: billingNoteTransaction.id,
    transactionId: billingNoteTransaction.transactionId,
    transactionType: billingNoteTransaction.transactionType,
    transactionNumber: billingNoteTransaction.transactionNumber,
    transactionFromCurrencyNetAmount: billingNoteTransaction.transactionFromCurrencyNetAmount,
    transactionToCurrencyNetAmount: billingNoteTransaction.transactionToCurrencyNetAmount,
    date: billingNoteTransaction.date,
    dueDate: billingNoteTransaction.dueDate,
    referenceList: ConvertToBillingNoteTransactionReferenceList(billingNoteTransaction.referenceList),
    taxStatus: 0,
    isLock: true,
    isNoneOrNotSpecifyWht: billingNoteTransaction.isNoneOrNotSpecifyWht,
    isBillingNoteTransactionItemOverNetTotal: false,
    billedPercent: 1,
    billedToCurrencyAmount: billingNoteTransaction.currency.netAmount.ToNumber().ToAccountingRoundUpNumber(),
    billedFromCurrencyAmount: billingNoteTransaction.summary.netAmount.ToNumber().ToAccountingRoundUpNumber(),
    summary: GetBillingNoteTransactionSummaryDetail(billingNoteTransaction.summary),
    currency: GetBillingNoteTransactionCurrencyDetail(billingNoteTransaction.currency),
    billingNoteTransactionItemList: ConvertBillingNoteTransactionItemList(
      billingNoteTransaction.billingNoteTransactionItemList
    ),
    summaryDefault: {},
    currencyDefault: {},
    billingNoteTransactionItemDefaultList: [],
  };
}
function GetBillingNoteTransactionDetailList(billingNoteTransactionList) {
  const selectedBillingNoteTransactionList = [];
  if (billingNoteTransactionList && billingNoteTransactionList.length > 0) {
    for (const selectedTransactionRaw of billingNoteTransactionList) {
      selectedBillingNoteTransactionList.push(GetBillingNoteTransactionDetail(selectedTransactionRaw));
    }
  }
  return selectedBillingNoteTransactionList;
}

export function GetOptionBillingNoteTransactionTableList(financeType) {
  let options = [];

  const isPackageCanUseInvoiceReceipt = userHelper.GetmerchantPackageRight().account.expense.invoiceReceipt;

  const depositOption = {
    value: Enums.OptionBillingNoteTransactionType.Deposit,
    name: financeType === Enums.FinanceType.InFlow ? i18n.t("Deposit_Receipt") : i18n.t("Deposit_Payment"),
  };

  const invoiceOption = {
    value: Enums.OptionBillingNoteTransactionType.Invoice,
    name:
      financeType === Enums.FinanceType.InFlow
        ? i18n.t("Invoice")
        : i18n.t("Menu_PurchaseInventoryRecord/RecordExpense"),
  };

  const debitNoteOption = {
    value: Enums.OptionBillingNoteTransactionType.DebitNote,
    name: financeType === Enums.FinanceType.InFlow ? i18n.t("Debit_Note") : i18n.t("Receive_Debit_Note"),
  };

  const invoiceReceiptOption = {
    value: Enums.OptionBillingNoteTransactionType.InvoiceReceipt,
    name: i18n.t("Invoice_Receipt"),
  };

  const allOption = {
    value: Enums.OptionBillingNoteTransactionType.All,
    name: i18n.t("All"),
  };

  options.push(depositOption);

  if (financeType === Enums.FinanceType.OutFlow && isPackageCanUseInvoiceReceipt) {
    options.push(invoiceReceiptOption);
  }

  options.push(invoiceOption);
  options.push(debitNoteOption);
  options.push(allOption);

  return options;
}
export default {
  MapTransactionToBillingNoteTransactionList(
    billingNoteTransactionList,
    billingNoteTransactionInvoiceMap,
    billingNoteTransactionDebitNoteMap,
    billingNoteTransactionDepositMap,
    billingNoteTransactionInvoiceReceiptMap
  ) {
    MapTransactionToBillingNoteTransactionList(
      billingNoteTransactionList,
      billingNoteTransactionInvoiceMap,
      billingNoteTransactionDebitNoteMap,
      billingNoteTransactionDepositMap,
      billingNoteTransactionInvoiceReceiptMap
    );
  },
  ConvertToBillingNoteTransactionForCreate(_billingNoteTransaction) {
    return ConvertToBillingNoteTransactionForCreate(_billingNoteTransaction);
  },
  SetBillingNoteSummaryToTransactionCreate(transactionCreate) {
    return SetBillingNoteSummaryToTransactionCreate(transactionCreate);
  },
  GetSelectedToBillingNoteTransactionList(selectedBillingNoteTransactionRawList) {
    return GetSelectedToBillingNoteTransactionList(selectedBillingNoteTransactionRawList);
  },
  GetBillingNoteTransactionItemToSelectedTransaction(billingNoteTransactionItemRaw) {
    return GetBillingNoteTransactionItemToSelectedTransaction(billingNoteTransactionItemRaw);
  },
  SetBillingNoteTransactionListToTransactionCreate(
    transactionCreate,
    selectedBillingNoteTransactionList,
    selectedBillingNoteTransactionFromCreatePage
  ) {
    return SetBillingNoteTransactionListToTransactionCreate(
      transactionCreate,
      selectedBillingNoteTransactionList,
      selectedBillingNoteTransactionFromCreatePage
    );
  },
  SetBillingNoteTransactionSummaryList(selectedBillingNoteTransactionList) {
    return SetBillingNoteTransactionSummaryList(selectedBillingNoteTransactionList);
  },
  SortingData(selectedBillingNoteTransactionList) {
    return SortingData(selectedBillingNoteTransactionList);
  },
  SetAllocateAmountForBillingNoteTransactionItemList(selectedBillingNoteTransactionList) {
    return SetAllocateAmountForBillingNoteTransactionItemList(selectedBillingNoteTransactionList);
  },
  CalculateBillingNoteTransactionItem(billingNoteTransactionItem) {
    return CalculateBillingNoteTransactionItem(billingNoteTransactionItem);
  },
  ConvertFromInvoiceToBillingNoteTransactionList(invoiceList) {
    return ConvertFromInvoiceToBillingNoteTransactionList(invoiceList);
  },
  ConvertFromDebitNoteToBillingNoteTransactionList(debitNoteList) {
    return ConvertFromDebitNoteToBillingNoteTransactionList(debitNoteList);
  },
  ConvertFromDepositToBillingNoteTransactionList(depositList) {
    return ConvertFromDepositToBillingNoteTransactionList(depositList);
  },
  ConvertFromInvoiceReceiptToBillingNoteTransactionList(invoiceReceiptList) {
    return ConvertFromInvoiceReceiptToBillingNoteTransactionList(invoiceReceiptList);
  },
  ConvertFromDepositToBillingNoteTransaction(depositList) {
    return ConvertFromDepositToBillingNoteTransaction(depositList);
  },
  ConvertFromInvoiceReceiptToBillingNoteTransaction(invoiceReceiptList) {
    return ConvertFromInvoiceReceiptToBillingNoteTransaction(invoiceReceiptList);
  },
  GetCreateBillingNoteInput(status, transaction) {
    return GetCreateBillingNoteInput(status, transaction);
  },
  GetCreateBillingNoteTransactionList(billingNoteTransactionRawList) {
    return GetCreateBillingNoteTransactionList(billingNoteTransactionRawList);
  },
  GetBillingNoteTransactionForEdit(billingNoteTransaction) {
    return GetBillingNoteTransactionForEdit(billingNoteTransaction);
  },
  GetMainModelBillingNoteTransaction(billingNoteTransaction) {
    return GetBillingNoteTransactionForEdit(billingNoteTransaction);
  },
  CalculateToCurrencyPrice(billingNoteTransactionItem) {
    return CalculateToCurrencyPrice(billingNoteTransactionItem);
  },
  CalculateFromCurrencyPrice(billingNoteTransactionItem) {
    return CalculateFromCurrencyPrice(billingNoteTransactionItem);
  },
  CalculateToCurrencyNetTotal(billingNoteTransactionItem, taxStatus) {
    return CalculateToCurrencyNetTotal(billingNoteTransactionItem, taxStatus);
  },
  SetBillingNoteTransactionSummaryByBillingNoteTransactionItem(billingNoteTransaction) {
    return SetBillingNoteTransactionSummaryByBillingNoteTransactionItem(billingNoteTransaction);
  },
  SetEditBillingNoteTransactionWithTransactionItem(transactionItem, editBillingNoteTransactionWithTransactionItem) {
    return SetEditBillingNoteTransactionWithTransactionItem(
      transactionItem,
      editBillingNoteTransactionWithTransactionItem
    );
  },
  SetEditBillingNote(transaction, transactionDetail) {
    return SetEditBillingNote(transaction, transactionDetail);
  },
  ConvertBillingNoteTransactionItemList(billingNoteTransactionItemRawList) {
    return ConvertBillingNoteTransactionItemList(billingNoteTransactionItemRawList);
  },
  ConvertToBillingNoteTransactionReferenceList(referenceRawList) {
    return ConvertToBillingNoteTransactionReferenceList(referenceRawList);
  },
  LoadEditBillingNoteTransactionItem(billingNoteTransaction) {
    return LoadEditBillingNoteTransactionItem(billingNoteTransaction);
  },
  GetBillingNoteTransactionDetailList(billingNoteTransactionList) {
    return GetBillingNoteTransactionDetailList(billingNoteTransactionList);
  },
};
